// React and Material-UI imports
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import WebIcon from "@material-ui/icons/Web";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import Card from "components/Card/Card";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import Divider from "@material-ui/core/Divider";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import { useSnackbar } from "notistack";
import { Typography } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import PersonIcon from "@material-ui/icons/Person";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import StayCurrentPortraitIcon from "@material-ui/icons/StayCurrentPortrait";
import PublicIcon from "@material-ui/icons/Public";
import LocationCityRoundedIcon from "@material-ui/icons/LocationCityRounded";
import NearMeRoundedIcon from "@material-ui/icons/NearMeRounded";
import RoomIcon from "@material-ui/icons/Room";
import AltRouteIcon from "@mui/icons-material/AltRoute";

// Asset imports
import closeImage from "assets/img/Close_Image.png";
// Material-UI hooks and utilities
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

// Custom styles and components
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import { CardActions } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-react/components/businessForm";
import Modal from "@material-ui/core/Modal";
import AppLoader from "components/AppLoader/Index";

// Redux actions and utilities
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import {
  getRoutingNumberData,
  emptyMerchantRTNReduxState,
  getAccountNumberData,
  emptyMerchantAccReduxState,
  getEmailList,
  getEmailData,
  emptyEmailListReduxState,
} from "Redux/Actions/merchantInformation";
import CheckIcon from "@material-ui/icons/Check";
import { useDispatch } from "react-redux";
import debounce from "lodash/debounce";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import CloseIcon from "@material-ui/icons/Close";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";
import ListItemText from "@material-ui/core/ListItemText";
import { locationCity } from "../../constant/locationConstant";
import { getCountryTypeList } from "../../Redux/Actions/ProvideRegistration";
import {
  getMerchantListData,
  getMerchantGroupCode,
  getRtpAch,
} from "../../Redux/Actions/merchantInformation";
import {
  sendInviteApiCall,
  submitApiCall,
  submitBSApiCall,
} from "../../actions/Operations";
import { actionPermission, permissionCheck } from "../../Utils/commonUtils";
import EmailAutofill from "./EmailAutofill";
import { profileCodePermissionCheck, serviceCodeValues } from "../../Utils/commonUtils";
import { cache } from "../../Redux/Helper/fetch";
import { GET_MERCHANT_LIST } from "../../Uintls/Urls";

// Custom hook for styles
const useStyles = makeStyles(styles);

function Signup(props) {
  // React hooks for state management and lifecycle
  const [validationModal, setValidationModal] = React.useState(false); // State for validation modal visibility
  const [assignGroupsModal, setAssignGroupsModal] = React.useState(false); // State for assign groups modal visibility
  const { enqueueSnackbar } = useSnackbar(); // Snackbar for notifications
  const [errorMessage, setErrorMessage] = React.useState(false); // State for error messages
  const theme = useTheme(); // Theme hook for Material-UI
  const [id, setId] = React.useState(null); // State for storing ID from URL
  const smallDevice = useMediaQuery(theme.breakpoints.down("xs")); // Media query for small devices
  const [sameAsMailing, setSameAsMailing] = React.useState(true); // State for "same as mailing" checkbox
  const classes = useStyles(); // Custom styles hook
  const [loading, setLoading] = React.useState(false); // State for loading indicator
  const [managerOBJid, setManagerOBJid] = React.useState(); // State for manager object ID
  const [businessOBJid, setBusinessOBJid] = React.useState(); // State for business object ID
  const profileId = localStorage.getItem("profileId"); // Retrieve profile ID from local storage
  const menu = JSON.parse(localStorage.getItem("menu")); // Retrieve menu data from local storage
  const profileCode = menu?.Role_Permission_Data?.Profile_Code; // Retrieve profile code from menu
  const windowWidthLG = useMediaQuery(theme.breakpoints.up("lg")); // Media query for large devices
  const [disabled1, setDisabled1] = React.useState(false); // State for disabling certain inputs
  const [valueRadio, setValueRadio] = React.useState("WEB"); // State for radio button value
  const [rtpValue, setRTPValue] = React.useState(false); // State for RTP value
  const [serviceKeyVisible, setServiceKeyVisible] = React.useState(false); // State for RTP value
  const [vikExclude, setVIKExclude] = React.useState(false); // State for VIK exclude value
  const [CPR, setCPR] = React.useState(false); // State for CPR value
  const [achValue, setACHValue] = React.useState(false); // State for ACH value
  const [balanceCheckProvider, setBalanceCheckProvider] = React.useState(["None"]); // State for balance check provider
  const [isRevealAcn, setIsRevealAcn] = React.useState(false); // State for revealing account number
  const [isRevealAcnConfirm, setIsRevealAcnConfirm] = React.useState(false); // State for revealing confirm account number
  const [confirmAccountNumberVisible, setConfirmAccountNumberVisible] =
    React.useState(false); // State for confirm account number visibility
  const [confirmRoutingNumberVisible, setConfirmRoutingNumberVisible] =
    React.useState(false); // State for confirm routing number visibility
  const [selectedUser, setSelectedUser] = React.useState({}); // State for selected user
  const [submitDisabled, setSubmitDisabled] = React.useState(true); // State for disabling submit button
  const [filedsDisabled, setFiledDisabled] = React.useState(false); // State for disabling fields
  const dispatch = useDispatch(); // Redux dispatch hook
  const [isAllSelected, setIsAllSelected] = React.useState(false); // State for "select all" checkbox
  const [selectedRows, setSelectedRows] = React.useState([]); // State for selected rows in a table
  const [accountAccessibility, setAccountAccessibility] = React.useState([]); // State for account accessibility
  const tableData = props.marchantGroupCodeList?.data; // Retrieve table data from props
  const [notificationFileSize, setNotificationFileSize] = useState("");
  const [statusFileSize, setStatusFileSize] = useState("");
  const [errorMessageStatus, setErrorMessageStatus] = useState("");
  const [inputValueStatus, setInputValueStatus] = useState("");
  const [errorNotification, setErrorNotification] = useState(false);
  const [errorStatus, setErrorStatus] = useState(false);
  const [inputValueNotification, setInputValueNotification] = useState("");
  const [errorMessageNotification, setErrorMessageNotification] = useState("");
  const [checkValue] = useState(false);
  // State for form values
  console.log("props,", props);
  const [values, handleInput] = React.useState({
    Requested_for_id: "",
    UpdateMg_id: "",
    Requested_by_id: "",
    Invite_Mail_Status: false,
    businessName: "",
    dba: "",
    businessWebsite: "",
    bsinessDescription: "",
    businessRoom: "",
    businessFloor: "",
    businessStreet: "",
    businessCountry: "",
    businessState: "",
    businessCity: "",
    businessPostalCode: "",
    mailingRoom: "",
    mailingFloor: "",
    mailingStreet: "",
    mailingCountry: "US",
    mailingState: "",
    mailingCity: "",
    mailingPostalCode: "",
    routingNumber: "",
    accountNumber: "",
    confirmAccountNumber: "",
    confirmRoutingNumber: "",
    bankDetailsCannotBeEdited: false,
    AddressDetailsChecked: true,
    feeTypeSurcharge: true,
    feeRate: "",
    serviceKey: "",
    perTransactionFee: "",
    percentageFee: "",
    aboveTransactionValue: "",
    none: "",
    feeCanNotBeEdited: false,
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    managerRoom: "",
    managerFloor: "",
    managerStreet: "",
    managerCountry: "",
    managerState: "",
    managerCity: "",
    managerPostalCode: "",
    Manager_id: "",
    userId: "",
    Status_Code: "",
    Balance_Check_Provider: ["None"],
    mgStatusObjId: "",
  });

  // State for validation errors
  const [validationError, setVlidationError] = React.useState({
    Invite_Mail_Status: false,
    businessName: false,
    dba: false,
    businessWebsite: false,
    bsinessDescription: false,
    businessRoom: false,
    businessFloor: false,
    businessStreet: false,
    businessCountry: false,
    businessState: false,
    businessCity: false,
    businessPostalCode: false,
    mailingRoom: false,
    mailingFloor: false,
    mailingStreet: false,
    mailingCountry: false,
    mailingState: false,
    mailingCity: false,
    mailingPostalCode: false,
    routingNumber: false,
    accountNumber: false,
    confirmAccountNumber: false,
    confirmRoutingNumber: false,
    feeRate: false,
    serviceKey: false,
    perTransactionFee: false,
    percentageFee: false,
    aboveTransactionValue: false,
    none: false,
    firstName: false,
    lastName: false,
    phoneNumber: false,
    email: false,
    managerRoom: false,
    managerFloor: false,
    managerStreet: false,
    managerCountry: false,
    managerState: false,
    managerCity: false,
    managerPostalCode: false,
    Manager_id: false,
    userId: false,
    Status_Code: false,
    balanceCheckProvider: false,
  });
  console.log("validationError", validationError);
  const checkValidation = (saveDraft = false) => {
    let validate = true;
    const error = { ...validationError };
    const {
      AddressDetailsChecked,
      mailingRoom,
      mailingFloor,
      mailingStreet,
      mailingCountry,
      mailingState,
      mailingCity,
      mailingPostalCode,
    } = values;

    if (!rtpValue) {
      error.routingNumber = false;
      error.confirmRoutingNumber = false;
      error.accountNumber = false;
      error.confirmAccountNumber = false;
      error.feeRate = false;
      error.perTransactionFee = false;
      error.percentageFee = false;
      error.aboveTransactionValue = false;
    }

    if (!achValue) {
      error.serviceKey = false;
    }

    for (const key in values) {
      if (rtpValue === true) {
        if (
          (values[key] === "" ||
            values[key] === null ||
            values[key] === undefined) &&
          (key === "businessName" ||
            key === "dba" ||
            key === "feeRate" ||
            key === "firstName" ||
            key === "lastName" ||
            key === "phoneNumber" ||
            key === "businessPostalCode" ||
            key === "managerCity" ||
            key === "managerPostalCode" ||
            key === "managerState" ||
            key === "managerCountry" ||
            key === "managerStreet" ||
            key === "accountNumber" ||
            key === "routingNumber" ||
            key === "businessCity" ||
            key === "businessState" ||
            key === "businessCountry" ||
            key === "businessStreet" ||
            (key === "mailingCity" && !values.AddressDetailsChecked) ||
            (key === "mailingState" && !values.AddressDetailsChecked) ||
            (key === "mailingCountry" && !values.AddressDetailsChecked) ||
            (key === "mailingStreet" && !values.AddressDetailsChecked) ||
            (key === "mailingPostalCode" && !values.AddressDetailsChecked) ||
            key === "email")
        ) {
          error[key] = true;
          validate = false;
        }
      }

      if (achValue === true) {
        if (
          (values[key] === "" ||
            values[key] === null ||
            values[key] === undefined) &&
          (key === "businessName" ||
            key === "dba" ||
            (
              Array.isArray(values.Balance_Check_Provider)
                ? values.Balance_Check_Provider.includes("DecisionLogic Service")
                : values.Balance_Check_Provider === "DecisionLogic Service"
            ) &&
            key === "serviceKey" ||
            key === "firstName" ||
            key === "lastName" ||
            key === "phoneNumber" ||
            key === "businessPostalCode" ||
            key === "managerCity" ||
            key === "managerPostalCode" ||
            key === "managerState" ||
            key === "managerCountry" ||
            key === "managerStreet" ||
            key === "businessCity" ||
            key === "businessState" ||
            key === "businessCountry" ||
            key === "businessStreet" ||
            (key === "mailingCity" && !values.AddressDetailsChecked) ||
            (key === "mailingState" && !values.AddressDetailsChecked) ||
            (key === "mailingCountry" && !values.AddressDetailsChecked) ||
            (key === "mailingStreet" && !values.AddressDetailsChecked) ||
            (key === "mailingPostalCode" && !values.AddressDetailsChecked) ||
            key === "email")
        ) {
          error[key] = true;
          validate = false;
        }
      }

      if (!rtpValue && !achValue &&
        (values[key] === "" ||
          values[key] === null ||
          values[key] === undefined) &&
        (key === "businessName" ||
          key === "dba" ||
          key === "firstName" ||
          key === "lastName" ||
          key === "phoneNumber" ||
          key === "businessPostalCode" ||
          key === "managerCity" ||
          key === "managerPostalCode" ||
          key === "managerState" ||
          key === "managerCountry" ||
          key === "managerStreet" ||
          key === "businessCity" ||
          key === "businessState" ||
          key === "businessCountry" ||
          key === "businessStreet" ||
          (key === "mailingCity" && !values.AddressDetailsChecked) ||
          (key === "mailingState" && !values.AddressDetailsChecked) ||
          (key === "mailingCountry" && !values.AddressDetailsChecked) ||
          (key === "mailingStreet" && !values.AddressDetailsChecked) ||
          (key === "mailingPostalCode" && !values.AddressDetailsChecked) ||
          key === "email")
      ) {
        error[key] = true;
        validate = false;
      }

      if (values.AddressDetailsChecked) {
        error.mailingCity = false;
        error.mailingState = false;
        error.mailingCountry = false;
        error.mailingStreet = false;
        error.mailingPostalCode = false;
      }

      if (key === "lastName") {
        if (/^\d/.test(values[key])) {
          error[key] = true;
          validate = false;
        }
      }

      if (key === "firstName") {
        if (/^\d/.test(values[key])) {
          error[key] = true;
          validate = false;
        }
      }

      if (key === "phoneNumber") {
        if (
          values[key] === "" ||
          values[key] === null ||
          values[key] === undefined
        ) {
          error[key] = true;
          validate = false;
        } else if (values[key]?.length !== 10) {
          error[key] = true;
          validate = false;
        }
      }

      if (key === "routingNumber") {
        if (!rtpValue) {
          error.routingNumber = false;
          error.confirmRoutingNumber = false;
        } else if (confirmRoutingNumberVisible) {
          if (
            values[key] !== "" &&
            values[key] !== null &&
            (values[key] !== values.confirmRoutingNumber ||
              values[key].length !== 9 ||
              !props.routingNumberData?.available ||
              values.confirmRoutingNumber === "" ||
              values.confirmRoutingNumber === null)
          ) {
            error[key] = true;
            error.confirmRoutingNumber = true;
            validate = false;
          }
        } else if (
          values[key] !== "" &&
          values[key] !== null &&
          values[key].length !== 9
        ) {
          error[key] = true;
          validate = false;
        } else if (
          rtpValue &&
          (values.routingNumber === "" ||
            values.routingNumber === null ||
            values.routingNumber === undefined)
        ) {
          error[key] = true;
          validate = false;
        }
      }

      if (key === "accountNumber") {
        if (!rtpValue) {
          error.accountNumber = false;
          error.confirmAccountNumber = false;
        } else if (confirmAccountNumberVisible) {
          if (
            (values[key] !== "" &&
              values[key] !== null &&
              (values[key] !== values.confirmAccountNumber ||
                values[key].length < 8 ||
                values[key].length > 17 ||
                !props.accountNumberData.status)) ||
            values.confirmAccountNumber === "" ||
            values.confirmAccountNumber === null
          ) {
            error[key] = true;
            error.confirmAccountNumber = true;
            validate = false;
          }
        } else if (
          values[key] !== "" &&
          values[key] !== null &&
          (values[key].length < 8 || values[key].length > 17)
        ) {
          error[key] = true;
          validate = false;
        } else if (
          rtpValue &&
          (values.accountNumber === "" ||
            values.accountNumber === null ||
            values.accountNumber === undefined)
        ) {
          error[key] = true;
          validate = false;
        }
      }

      if (key === "feeRate") {
        if (!rtpValue) {
          error.perTransactionFee = false;
          error.percentageFee = false;
          error.aboveTransactionValue = false;
        } else {
          if (values.feeRate === "Per Transaction" && !values.perTransactionFee) {
            error.perTransactionFee = true;
            validate = false;
          }
          if (values.feeRate === "Percentage" && !values.percentageFee) {
            error.percentageFee = true;
            validate = false;
          }
          if (
            values.feeRate === "Per transaction + Percentage" &&
            (!values.perTransactionFee ||
              !values.percentageFee ||
              !values.aboveTransactionValue)
          ) {
            error.perTransactionFee = !values.perTransactionFee;
            error.percentageFee = !values.percentageFee;
            error.aboveTransactionValue = !values.aboveTransactionValue;
            validate = false;
          }
        }
      }
      if (
        key === "email" &&
        (!values[key] || !/^\S+@\S+\.\S+$/.test(values[key]))
      ) {
        error[key] = true;
        validate = false;
      }
    }
    // Open Banking Provider is mandatory for ACH
    if (
      achValue &&
      (!values.Balance_Check_Provider ||
        values.Balance_Check_Provider.length === 0)
    ) {
      error.balanceCheckProvider = true;
      validate = false;
    } else {
      error.balanceCheckProvider = false;
    }
    setVlidationError(error);
    if (!saveDraft) {
      if (!validate) {
        setValidationModal(true);
      }
    }
    if (saveDraft) {
      if (!validate) {
        setValidationModal(true);
      }
    }
    return validate;
  };
  const handleInfoStatus = (e) => {
    const value = e.target.value;
    setInputValueStatus(value);

    // URL validation regex

    // URL validation regex
    const urlPattern =
      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(:\d{1,5})?(\/.*)?$/;

    if (value && !urlPattern.test(value)) {
      setErrorStatus(true);
      setErrorMessageStatus("Enter a valid URL (e.g., https://example.com)");
    } else {
      setErrorStatus(false);
      setErrorMessageStatus("");
    }
  };
  const handleInfoNotification = (e) => {
    const value = e.target.value;
    setInputValueNotification(e.target.value);
    // URL validation regex

    // URL validation regex
    const urlPattern =
      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(:\d{1,5})?(\/.*)?$/;

    if (value && !urlPattern.test(value)) {
      setErrorNotification(true);
      setErrorMessageNotification(
        "Enter a valid URL (e.g., https://example.com)"
      );
    } else {
      setErrorNotification(false);
      setErrorMessageNotification("");
    }
  };
  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setIsAllSelected(checked);

    if (checked) {
      // Select all rows only if tableData is defined and is an array
      setSelectedRows(Array.isArray(tableData) ? [...tableData] : []);
    } else {
      // Deselect all rows
      setSelectedRows([]);
    }
  };

  const handleCheckboxChange = (row) => {
    setSelectedRows((prevSelected) => {
      const isDuplicate = prevSelected.some((item) => item.id === row.id);
      let updatedSelection;

      if (isDuplicate) {
        // Remove the selected row
        updatedSelection = prevSelected.filter((item) => item.id !== row.id);
      } else {
        // Add the new selection
        updatedSelection = [...prevSelected, { ...row }];
      }

      // Check if all rows are selected and update `setIsAllSelected`
      setIsAllSelected(updatedSelection.length === tableData.length);

      return updatedSelection;
    });
  };

  // Remove a chip
  const handleDeleteChip = (rowToDelete) => {
    setSelectedRows((prevSelected) =>
      prevSelected.filter((row) => row !== rowToDelete));
  };
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const idFromUrl = queryParams.get("id");
    setId(idFromUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (props?.merchantListData?.emailData) {
      const {
        City,
        Country,
        First_Name,
        Floor,
        Last_Name,
        Phone_Number,
        PostalCode,
        Room,
        State,
        Street,
      } = props?.merchantListData?.emailData;
      handleInput((prevValues) => ({
        ...prevValues,
        managerRoom: Room,
        managerFloor: Floor,
        managerStreet: Street,
        managerCountry: Country,
        managerState: State,
        managerCity: City,
        managerPostalCode: PostalCode,
        firstName: First_Name,
        lastName: Last_Name,
        phoneNumber: Phone_Number,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.emailData]);

  React.useEffect(() => {
    if (id) {
      const payload = {
        _id: id,
      };

      const createCacheKey = (params) => {
        const filteredParams = Object.fromEntries(
          Object.entries(params).filter(
            ([, value]) => value !== undefined && value !== null && value !== ""
          )
        );
        return JSON.stringify(filteredParams);
      };

      const cacheKey = createCacheKey({
        url: GET_MERCHANT_LIST,
        body: payload,
      });

      // Delete only specific cache
      cache.delete(cacheKey);

      // Now API will call fresh
      props.getMerchantListData(payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  React.useEffect(() => {
    props.getRtpAch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkValidationSubmit = (saveDraft = false) => {
    let validate = true;
    const error = { ...validationError };

    if (!rtpValue) {
      error.routingNumber = false;
      error.confirmRoutingNumber = false;
      error.accountNumber = false;
      error.confirmAccountNumber = false;
      error.feeRate = false;
      error.perTransactionFee = false;
      error.percentageFee = false;
      error.aboveTransactionValue = false;
    }

    if (!achValue) {
      error.serviceKey = false;
    }

    for (const key in values) {
      if (rtpValue === true) {
        if (
          (values[key] === "" ||
            values[key] === null ||
            values[key] === undefined) &&
          (key === "businessName" ||
            key === "dba" ||
            key === "feeRate" ||
            key === "firstName" ||
            key === "lastName" ||
            key === "businessPostalCode" ||
            key === "managerCity" ||
            key === "managerPostalCode" ||
            key === "managerState" ||
            key === "managerCountry" ||
            key === "managerStreet" ||
            key === "phoneNumber" ||
            key === "accountNumber" ||
            key === "routingNumber" ||
            key === "businessCity" ||
            key === "businessState" ||
            key === "businessCountry" ||
            key === "businessStreet" ||
            (key === "mailingCity" && !values.AddressDetailsChecked) ||
            (key === "mailingState" && !values.AddressDetailsChecked) ||
            (key === "mailingCountry" && !values.AddressDetailsChecked) ||
            (key === "mailingStreet" && !values.AddressDetailsChecked) ||
            (key === "mailingPostalCode" && !values.AddressDetailsChecked) ||
            key === "email")
        ) {
          error[key] = true;
          validate = false;
        }
      }

      if (achValue === true) {
        if (
          (values[key] === "" ||
            values[key] === null ||
            values[key] === undefined) &&
          (key === "businessName" ||
            key === "dba" ||
            (
              Array.isArray(values.Balance_Check_Provider)
                ? values.Balance_Check_Provider.includes("DecisionLogic Service")
                : values.Balance_Check_Provider === "DecisionLogic Service"
            ) &&
            key === "serviceKey" ||
            key === "firstName" ||
            key === "lastName" ||
            key === "businessPostalCode" ||
            key === "managerCity" ||
            key === "managerPostalCode" ||
            key === "managerState" ||
            key === "managerCountry" ||
            key === "managerStreet" ||
            key === "phoneNumber" ||
            key === "businessCity" ||
            key === "businessState" ||
            key === "businessCountry" ||
            key === "businessStreet" ||
            (key === "mailingCity" && !values.AddressDetailsChecked) ||
            (key === "mailingState" && !values.AddressDetailsChecked) ||
            (key === "mailingCountry" && !values.AddressDetailsChecked) ||
            (key === "mailingStreet" && !values.AddressDetailsChecked) ||
            (key === "mailingPostalCode" && !values.AddressDetailsChecked) ||
            key === "email")
        ) {
          error[key] = true;
          validate = false;
        }
      }

      if (!rtpValue && !achValue &&
        (values[key] === "" ||
          values[key] === null ||
          values[key] === undefined) &&
        (key === "businessName" ||
          key === "dba" ||
          key === "firstName" ||
          key === "lastName" ||
          key === "businessPostalCode" ||
          key === "managerCity" ||
          key === "managerPostalCode" ||
          key === "managerState" ||
          key === "managerCountry" ||
          key === "managerStreet" ||
          key === "phoneNumber" ||
          key === "businessCity" ||
          key === "businessState" ||
          key === "businessCountry" ||
          key === "businessStreet" ||
          (key === "mailingCity" && !values.AddressDetailsChecked) ||
          (key === "mailingState" && !values.AddressDetailsChecked) ||
          (key === "mailingCountry" && !values.AddressDetailsChecked) ||
          (key === "mailingStreet" && !values.AddressDetailsChecked) ||
          (key === "mailingPostalCode" && !values.AddressDetailsChecked) ||
          key === "email")
      ) {
        error[key] = true;
        validate = false;
      }

      if (values.AddressDetailsChecked) {
        error.mailingCity = false;
        error.mailingState = false;
        error.mailingCountry = false;
        error.mailingStreet = false;
        error.mailingPostalCode = false;
      }

      if (key === "businessPostalCode") {
        if (values[key] !== "" && values[key]?.length !== 5) {
          validate = false;
          error[key] = true;
        }
        if (error[key]) {
          validate = false;
        }
      }
      if (key === "mailingPostalCode") {
        if (values[key] !== "" && values[key]?.length !== 5) {
          validate = false;
          error[key] = true;
        }
        if (error[key]) {
          validate = false;
        }
      }
      if (key === "routingNumber") {
        if (!rtpValue) {
          error.routingNumber = false;
          error.confirmRoutingNumber = false;
        } else if (values.bankDetailsCannotBeEdited) {
          if (
            (values[key] === "" && values[key] == null) ||
            values[key]?.length !== 9
          ) {
            error[key] = true;
            validate = false;
          }
        } else if (confirmRoutingNumberVisible) {
          if (
            values[key] === "" ||
            values[key]?.length !== 9 ||
            values[key] !== values.confirmRoutingNumber ||
            !props.routingNumberData?.available ||
            values.confirmRoutingNumber === "" ||
            values.confirmRoutingNumber === null
          ) {
            error[key] = true;
            error.confirmRoutingNumber = true;
            validate = false;
          }
        } else if (
          values[key] !== "" &&
          values[key] !== null &&
          values[key]?.length !== 9
        ) {
          error[key] = true;
          validate = false;
        } else if (
          rtpValue &&
          (values.routingNumber === "" ||
            values.routingNumber == null ||
            values.routingNumber === undefined)
        ) {
          error[key] = true;
          validate = false;
        }
      }

      if (key === "accountNumber") {
        if (!rtpValue) {
          error.accountNumber = false;
          error.confirmAccountNumber = false;
        } else if (values.bankDetailsCannotBeEdited) {
          if (
            (values[key] === "" && values[key] == null) ||
            (values[key]?.length < 8 && values[key]?.length > 17)
          ) {
            error[key] = true;
            validate = false;
          }
        } else if (confirmAccountNumberVisible) {
          if (
            values[key] === "" ||
            values[key]?.length < 8 ||
            values[key]?.length > 17 ||
            values[key] !== values.confirmAccountNumber ||
            !props.accountNumberData.status ||
            values.confirmAccountNumber === "" ||
            values.confirmAccountNumber === null
          ) {
            error[key] = true;
            error.confirmAccountNumber = true;
            validate = false;
          }
        } else if (
          values[key] !== "" &&
          values[key] !== null &&
          (values[key]?.length < 8 || values[key]?.length > 17)
        ) {
          error[key] = true;
          validate = false;
        } else if (
          rtpValue &&
          (values.accountNumber === "" ||
            values.accountNumber == null ||
            values.accountNumber === undefined)
        ) {
          error[key] = true;
          validate = false;
        }
      }
      if (key === "feeRate") {
        if (!rtpValue) {
          error.perTransactionFee = false;
          error.percentageFee = false;
          error.aboveTransactionValue = false;
        } else {
          if (values.feeRate === "Per Transaction" && !values.perTransactionFee) {
            error.perTransactionFee = true;
            validate = false;
          }
          if (values.feeRate === "Percentage" && !values.percentageFee) {
            error.percentageFee = true;
            validate = false;
          }
          if (
            values.feeRate === "Per transaction + Percentage" &&
            (!values.perTransactionFee ||
              !values.percentageFee ||
              !values.aboveTransactionValue)
          ) {
            error.perTransactionFee = !values.perTransactionFee;
            error.percentageFee = !values.percentageFee;
            error.aboveTransactionValue = !values.aboveTransactionValue;
            validate = false;
          }
        }
      }
    }
    // Open Banking Provider is mandatory for ACH
    if (
      achValue &&
      (!values.Balance_Check_Provider ||
        values.Balance_Check_Provider.length === 0)
    ) {
      error.balanceCheckProvider = true;
      validate = false;
    } else {
      error.balanceCheckProvider = false;
    }
    setVlidationError(error);
    if (!saveDraft) {
      if (!validate) {
        setValidationModal(true);
      }
    }
    if (saveDraft) {
      if (!validate) {
        setValidationModal(true);
      }
    }
    return validate;
  };
  const fetchEmailList = React.useCallback(
    debounce((query) => dispatch(getEmailList(query, "main")), 200),
    [dispatch]
  );

  const handleChangeRadio = (value) => {
    setValueRadio(value);
  };

  const onClose = () => {
    setAssignGroupsModal(false);
  };

  const handleEmailChange = (email, agentsList) => {
    const normalizedEmail = email.toLowerCase();
    handleInput((prevValues) => ({ ...prevValues, email: normalizedEmail }));

    setVlidationError((prevError) => ({
      ...prevError,
      email: !/^\S+@\S+\.\S+$/.test(normalizedEmail),
    }));

    if (normalizedEmail.length >= 4) {
      fetchEmailList(normalizedEmail);
    } else {
      handleInput((prevValues) => ({
        ...prevValues,
        managerRoom: "",
        managerFloor: "",
        managerStreet: "",
        managerCountry: "",
        managerState: "",
        managerCity: "",
        managerPostalCode: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
      }));
      dispatch(emptyEmailListReduxState());
    }

    const emailExists = agentsList?.includes(normalizedEmail);

    if (emailExists && /^\S+@\S+\.\S+$/.test(normalizedEmail)) {
      dispatch(getEmailData(normalizedEmail));
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const idFromUrl = queryParams.get("id");
    if (idFromUrl == null) {
      handleCheckboxChangeRtpAch(false, "VIKExclude");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const data = props.merchantListData?.merchantListData?.data;
    if (data) {
      const checkedServices = new Set();

      data.forEach((item) => {
        if (item?.ManagerStatus?.Status) {
          item.ManagerStatus.Status.forEach((access) => {
            if (access.Check === "true" || access.Check === true) {
              checkedServices.add({
                serviceCode: access.Service_Code,
                status: access.Status,
              });
            }
          });
        }
      });

      checkedServices.forEach(({ serviceCode }) => {
        handleCheckboxChangeRtpAch(true, serviceCode);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.merchantListData?.merchantListData]);

  useEffect(() => {
    const data =
      props.merchantListData.merchantListData &&
      props.merchantListData.merchantListData.data;
    if (data) {
      const balance_Check_Provider =
        data[0]?.Manager_Details?.Balance_Check_Provider || null;
      setBalanceCheckProvider(balance_Check_Provider);
      // Extract Group_Visibility array and set it to selectedRows
      const groupVisibility = data[0]?.Manager_Details?.Group_Visibility[0]?.groupCodes || [];
      setSelectedRows(groupVisibility);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.merchantListData?.merchantListData?.data]);
  const handleCheckboxChangeRtpAch = (event, Service_Code) => {
    debugger;
    const isChecked = event === true ? true : event?.target?.checked;
    // Handle specific logic for RTP and ACH
    if (Service_Code === serviceCodeValues.RTP) {
      setRTPValue(isChecked);
      handleInput({ ...values, feeRate: "" });
    }
    if (Service_Code === serviceCodeValues.VIKExclude) {
      setVIKExclude(isChecked);
      // handleInput({ ...values, feeRate: "" });
    }
    if (Service_Code === serviceCodeValues.CPR) {
      setCPR(isChecked);
      // handleInput({ ...values, feeRate: "" });
    }

    if (Service_Code === serviceCodeValues.ACH) {
      setACHValue(isChecked);
      setSelectedRows([]);
      setIsAllSelected(false);
      // Preserve the NEW/ADD default of ["None"] when user manually selects
      // ACH in a new form (no id in URL) and there is no existing provider.
      // For edit forms (id present) keep the existing behavior unchanged.
      try {
        const idFromUrl = new URLSearchParams(window.location.search).get("id");
        const selecting = isChecked === true;
        if (selecting) {
          if (idFromUrl == null) {
            const currentProvider = values.Balance_Check_Provider;
            const isEmptyProvider =
              currentProvider === "" ||
              currentProvider === null ||
              currentProvider === undefined ||
              (Array.isArray(currentProvider) && currentProvider.length === 0);
            if (isEmptyProvider) {
              handleInput({ ...values, Balance_Check_Provider: ["None"] });
              // Keep component state in sync so the UI continues to show None
              // without changing dropdown logic.
              if (typeof setBalanceCheckProvider === "function") {
                setBalanceCheckProvider(["None"]);
              }
            }
            // if provider already exists, do not overwrite it
          } else {
            // Edit form: preserve existing behavior
            handleInput({ ...values, Balance_Check_Provider: "" });
          }
        } else {
          // Unchecking ACH: preserve original behavior
          handleInput({ ...values, Balance_Check_Provider: "" });
        }
      } catch (e) {
        // In case URL parsing fails for any reason, fall back to original behavior
        handleInput({ ...values, Balance_Check_Provider: "" });
      }
    }

    // Update accountAccessibility state
    setAccountAccessibility((prev) => {
      if (isChecked || event === "true") {
        // Add the new service code if checked
        return [
          ...prev.filter((item) => item.Service_Code !== Service_Code),
          { Service_Code, Status: "Invited", Check: isChecked },
        ];
      }
      // Remove the service code if unchecked
      return prev.filter((item) => item.Service_Code !== Service_Code);
    });
  };

  useEffect(() => {
    if (props?.merchantListData?.emailListData?.data && values.email) {
      const emailExists = props.merchantListData.emailListData.data.includes(
        values.email
      );
      if (emailExists) {
        dispatch(getEmailData(values.email));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.emailListData?.data, values.email]);

  React.useEffect(() => {
    if (
      values.confirmAccountNumber !== "" &&
      values.accountNumber !== values.confirmAccountNumber
    ) {
      const error = { ...validationError, confirmAccountNumber: true };
      setVlidationError(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  React.useEffect(() => {
    if (
      values.confirmRoutingNumber !== "" &&
      values.routingNumber !== values.confirmRoutingNumber
    ) {
      const error = { ...validationError, confirmRoutingNumber: true };
      setVlidationError(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  React.useEffect(() => {
    if (!props.formData.countryTypeList) {
      props.getCountryTypeList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (id) {
      const addressChecked =
        props?.merchantListData?.merchantListData &&
        props?.merchantListData?.merchantListData?.data[0]
          ?.AddressDetailsChecked;
      if (addressChecked === true) {
        setSameAsMailing(true);
      } else {
        setSameAsMailing(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  React.useEffect(() => {
    setBusinessOBJid(
      props.signUpData.merchantInformation.merchantListData &&
      props.signUpData?.merchantInformation?.merchantListData?.data[0]?._id
    );
    setManagerOBJid(
      props.signUpData.merchantInformation.merchantListData &&
      props.signUpData?.merchantInformation?.merchantListData?.data[0]
        ?.Manager_Details?._id
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.signUpData?.merchantInformation?.merchantListData]);

  React.useEffect(() => {
    const result =
      props.merchantListData.merchantListData &&
      props.merchantListData.merchantListData.data.map((items) => ({
        uid: items?.uid,
        Account_id: items?.Account_id,
        AddressDetailsChecked: items?.AddressDetailsChecked,
        Business_Name: items?.Business_Name,
        Dba: items?.Dba,
        Business_Website: items?.Business_Website,
        Business_Description: items?.Business_Description,
        Business_Phone_Number: items?.Business_Phone_Number,
        Email: items?.Manager_Details?.Email,
        _id: items?._id,
        Created_By: items?.Created_By,
        Manager_id: items?.Manager_id,
        Invite_Date: items?.Invite_Date,
        Created_date: items?.Created_date,
        Updated_date: items?.Updated_date,
        First_Name: items?.Manager_Details?.First_Name,
        Last_Name: items?.Manager_Details?.Last_Name,
        Phone_Number: items?.Manager_Details?.Phone_Number,
        Status_Code: items.Status_Code,
        Business_Address_Room: items?.Business_Address?.Room_No,
        Business_Address_Floor: items?.Business_Address?.Floor,
        Business_Address_Street: items?.Business_Address?.Street,
        Business_Address_Country: items?.Business_Address?.Country,
        Business_Address_State: items?.Business_Address?.State,
        Business_Address_City: items?.Business_Address?.City,
        Business_Address_Postal_Code: items?.Business_Address?.Postal_Code,
        Mailing_Address_Room: items?.Mailing_Address?.Room_No,
        Mailing_Address_Floor: items?.Mailing_Address?.Floor,
        Mailing_Address_Street: items?.Mailing_Address?.Street,
        Mailing_Address_Country: items?.Mailing_Address?.Country,
        Mailing_Address_State: items?.Mailing_Address?.State,
        Mailing_Address_City: items?.Mailing_Address?.City,
        Mailing_Address_Postal_Code: items?.Mailing_Address?.PostalCode,
        Account_Number: items?.Banking_Details?.Account_Number,
        Routing_Number: items?.Banking_Details?.Routing_Number,
        Bank_Details_Cannot_Be_Edited:
          items?.Banking_Details?.bankDetailsCannotBeEdited,
        FeeType_Name: items?.FeeType?.FeeTypeName,
        FeeType_Discounted: items?.FeeType?.feeTypeDiscounted,
        FeeType_Surcharge: items?.FeeType?.feeTypeSurcharge,
        FeeType_perTransactionFee: items?.FeeType?.perTransactionFee,
        FeeType_percentageFee: items?.FeeType?.percentageFee,
        FeeType_aboveTransactionValue: items?.FeeType?.aboveTransactionValue,
        Fee_can_not_be_edited: items?.FeeType?.feeCanNotBeEdited,
        Manager_Details_Room: items?.Manager_Details?.Room,
        Manager_Details_Floor: items?.Manager_Details?.Floor,
        Manager_Details_Street: items?.Manager_Details?.Street,
        Manager_Details_Country: items?.Manager_Details?.Country,
        Manager_Details_State: items?.Manager_Details?.State,
        Manager_Details_City: items?.Manager_Details?.City,
        Manager_Details_PostalCode: items?.Manager_Details?.PostalCode,
        Requested_by_id: items?.Manager_Details?._id,
        UpdateMg_id: items?.Manager_Details?._id,
        Requested_for_id: items?._id,
        serviceKey: items?.Service_Key,
        Balance_Check_Provider: Array.isArray(items?.Balance_Check_Provider) ? items.Balance_Check_Provider.filter(x => x !== null) : [],
        mgStatusObjId: items?.ManagerStatus?._id,
      }));
    const newResult = result && result[0];
    if (newResult && values.businessName === "") {
      handleInput({
        ...values,
        Requested_by_id: newResult?.Requested_by_id,
        UpdateMg_id: newResult?.UpdateMg_id,
        Requested_for_id: newResult?.Requested_for_id,
        uid: newResult?.uid,
        Account_id: newResult?.Account_id,
        AddressDetailsChecked: newResult?.AddressDetailsChecked,
        businessName: newResult?.Business_Name,
        dba: newResult?.Dba,
        businessWebsite: newResult?.Business_Website,
        bsinessDescription: newResult?.Business_Description,
        businessRoom: newResult?.Business_Address_Room,
        businessFloor: newResult?.Business_Address_Floor,
        businessStreet: newResult?.Business_Address_Street,
        businessCountry: newResult?.Business_Address_Country,
        businessState: newResult?.Business_Address_State,
        businessCity: newResult?.Business_Address_City,
        businessPostalCode: newResult?.Business_Address_Postal_Code,
        mailingRoom: newResult?.Mailing_Address_Room,
        mailingFloor: newResult?.Mailing_Address_Floor,
        mailingStreet: newResult?.Mailing_Address_Street,
        mailingCountry: newResult?.Mailing_Address_Country,
        mailingState: newResult?.Mailing_Address_State,
        mailingCity: newResult?.Mailing_Address_City,
        mailingPostalCode: newResult?.Mailing_Address_Postal_Code,
        routingNumber: newResult?.Routing_Number,
        accountNumber: newResult?.Account_Number,
        feeRate: newResult?.FeeType_Name,
        serviceKey: newResult?.serviceKey,
        perTransactionFee: newResult?.FeeType_perTransactionFee,
        percentageFee: newResult?.FeeType_percentageFee,
        aboveTransactionValue: newResult?.FeeType_aboveTransactionValue,
        feeCanNotBeEdited: newResult?.Fee_can_not_be_edited,
        bankDetailsCannotBeEdited: newResult?.Bank_Details_Cannot_Be_Edited,
        firstName: newResult?.First_Name,
        lastName: newResult?.Last_Name,
        email: newResult?.Email,
        phoneNumber: newResult?.Phone_Number,
        managerRoom: newResult?.Manager_Details_Room,
        managerFloor: newResult?.Manager_Details_Floor,
        managerStreet: newResult?.Manager_Details_Street,
        managerCountry: newResult?.Manager_Details_Country,
        managerState: newResult?.Manager_Details_State,
        managerCity: newResult?.Manager_Details_City,
        managerPostalCode: newResult?.Manager_Details_PostalCode,
        Status_Code: newResult?.Status_Code,
        Business_id: newResult?._id,
        Balance_Check_Provider: newResult.Balance_Check_Provider,
        mgStatusObjId: newResult?.mgStatusObjId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  React.useEffect(() => {
    if (values.accountNumber === "" || values.routingNumber === "") {
      setDisabled1(true);
      handleInput((prevState) => ({
        ...prevState,
        bankDetailsCannotBeEdited: false,
      }));
    } else {
      setDisabled1(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.accountNumber, values.routingNumber]);

  useEffect(() => {
    props.emptyMerchantAccReduxState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(
    () => () => {
      dispatch(emptyEmailListReduxState());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch]
  );

  React.useEffect(() => {
    if (balanceCheckProvider) {
      handleInput({
        ...values,
        Balance_Check_Provider: balanceCheckProvider,
      });
      if (balanceCheckProvider.includes("DecisionLogic Service")) {
        setServiceKeyVisible(true);
      } else {
        setServiceKeyVisible(false);
        setVlidationError((prevError) => ({
          ...prevError,
          serviceKey: false,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [balanceCheckProvider]);

  React.useEffect(() => {
    const updatedError = { ...validationError };
    if (values.firstName) {
      onChange(values.firstName, "firstName");

      if (/^\d/.test(values.firstName)) {
        updatedError.firstName = true;
      } else {
        updatedError.firstName = false;
      }
    }
    if (values.lastName) {
      onChange(values.lastName, "lastName");

      if (/^\d/.test(values.lastName)) {
        updatedError.lastName = true;
      } else {
        updatedError.lastName = false;
      }
    }
    setVlidationError(updatedError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.firstName, values.lastName]);

  const handleUserSelect = (user) => {
    setSelectedUser(user);
    if (user) {
      dispatch(getEmailData(user));
    } else {
      handleInput((prevValues) => ({
        ...prevValues,
        managerRoom: "",
        managerFloor: "",
        managerStreet: "",
        managerCountry: "",
        managerState: "",
        managerCity: "",
        managerPostalCode: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
      }));
      dispatch(emptyEmailListReduxState());
    }
  };

  function formatPhoneNumber(v) {
    let r = v?.replace(/\D/g, "");
    if (r?.length > 11) {
      r = r?.replace(/^(\d\d\d)(\d{3})(\d{0,4}).*/, "$1-$2-$3");
      return r;
    }
    if (r?.length > 6) {
      r = r?.replace(/^(\d\d\d)(\d{3})(\d{0,4}).*/, "$1-$2-$3");
    } else if (r?.length > 3) {
      r = r?.replace(/^(\d\d\d)(\d{0,3})/, "$1-$2");
    } else {
      r = r?.replace(/^(\d*)/, "$1");
    }
    return r;
  }

  const handleFormSubmit = (value) => {
    // setSaveDraftClick(true);
    const updatedAccountAccessibility = accountAccessibility.map((item) => {
      if (item.Service_Code === "ACH" || item.Service_Code === "RTP") {
        return { ...item, Check: true }; // Set Check to true if selected
      }
      return item; // Keep other items unchanged
    });

    // Ensure both services exist, adding them if missing
    const services = ["ACH", "RTP", "VIKExclude", "CPR"];
    services.forEach((serviceCode) => {
      if (
        !updatedAccountAccessibility.some(
          (item) => item.Service_Code === serviceCode
        )
      ) {
        updatedAccountAccessibility.push({
          Service_Code: serviceCode,
          Status: "Invited",
          Check: null, // Add missing service with Check null
        });
      }
    });

    // setValidationModal(false);
    if (value === "submit") {
      const awaitingBusinessJoined = props?.merchantListData?.merchantListData?.data[0]?.awaitingBusinessJoined;
      if (awaitingBusinessJoined) {
        enqueueSnackbar("Click on 'Join Account' in the email received, and then login again to Submit.", {
          variant: "error",
        });
        return;
      }
      if (checkValidationSubmit(true)) {
        setLoading(true);
        const payload = {
          ...values,
          Module_Name: "Merchant Submit Page",
          Module_Code: 2,
          Status_Code: 1,
          Resend_Invite: null,
          Business_OBJid: values.Business_id,
          Manager_OBJid: values.UpdateMg_id,
          Manager_id: profileId,
        };
        if (profileCode === profileCodePermissionCheck.profileCode.VCS) {
          props.submitApiCall(
            payload,
            (res) => {
              setLoading(false);
              if (res.status === true) {
                enqueueSnackbar(`${res.message}`, {
                  variant: "success",
                });
                props.history.push(`/${props.mainData.app.layout}/Merchant`);
              }
            },
            (err) => {
              setLoading(false);
              enqueueSnackbar(`${err.message}`, {
                variant: "error",
              });
            }
          );
        } else {
          props.submitBSApiCall(
            payload,
            (res) => {
              setLoading(false);
              if (res.status === true) {
                enqueueSnackbar(`${res.message}`, {
                  variant: "success",
                });
                props.history.push(`/${props.mainData.app.layout}/Merchant`);
              }
            },
            (err) => {
              setLoading(false);
              enqueueSnackbar(`${err.message}`, {
                variant: "error",
              });
            }
          );
        }
      }
      setValidationModal(false);
    }
    if (value === "update") {
      if (checkValidation(true)) {
        setLoading(true);
        setValidationModal(false);
        const payload = {
          ...values,
          Module_Name: "Merchant Submit Page",
          Module_Code: 2,
          Status_Code: 1,
          Resend_Invite: null,
          Business_OBJid: values.Business_id,
          Manager_OBJid: values.UpdateMg_id,
          Manager_id: profileId,
          mgStatusObjId: values.mgStatusObjId,
          accountAccessibility: updatedAccountAccessibility,
          Platform_Accessibility: valueRadio,
          Group_Visibility: selectedRows,
          balanceCheckProvider,
        };
        if (profileCode === profileCodePermissionCheck.profileCode.VCS) {
          props.submitApiCall(
            payload,
            (res) => {
              setLoading(false);
              if (res.status === true) {
                enqueueSnackbar(`${res.message}`, {
                  variant: "success",
                });
                props.history.push(`/${props.mainData.app.layout}/Merchant`);
              }
            },
            (err) => {
              setLoading(false);
              enqueueSnackbar(`${err.message}`, {
                variant: "error",
              });
            }
          );
        } else {
          props.submitBSApiCall(
            payload,
            (res) => {
              setLoading(false);
              if (res.status === true) {
                enqueueSnackbar(`${res.message}`, {
                  variant: "success",
                });
                props.history.push(`/${props.mainData.app.layout}/Merchant`);
              }
            },
            (err) => {
              setLoading(false);
              enqueueSnackbar(`${err.message}`, {
                variant: "error",
              });
            }
          );
        }
      } else {
        setValidationModal(true);
      }
    }
  };

  const onFormSubbmit = (value) => {
    const updatedAccountAccessibility = accountAccessibility.map((item) => {
      if (item.Service_Code === "ACH" || item.Service_Code === "RTP") {
        return { ...item, Check: true }; // Set Check to true if selected
      }
      return item; // Keep other items unchanged
    });

    // Ensure both services exist, adding them if missing
    const services = ["ACH", "RTP"];
    services.forEach((serviceCode) => {
      if (
        !updatedAccountAccessibility.some(
          (item) => item.Service_Code === serviceCode
        )
      ) {
        updatedAccountAccessibility.push({
          Service_Code: serviceCode,
          Status: "Invited",
          Check: false, // Add missing service with Check false
        });
      }
    });

    setLoading(true);
    // setSaveDraftClick(true);

    setValidationModal(false);
    if (checkValidation(true)) {
      if (value === "saveDraft") {
        props.sendInviteApiCall(
          {
            ...values,
            Status_Code: 2,
            Business_OBJid: businessOBJid,
            Manager_OBJid: managerOBJid,
          },
          (res) => {
            setLoading(false);
            if (res.status === true) {
              enqueueSnackbar(`${res.message}`, {
                variant: "success",
              });
              props.history.push(`/${props.mainData.app.layout}/Merchant`);
            }
          },
          (err) => {
            setLoading(false);
            enqueueSnackbar(`${err.message}`, {
              variant: "error",
            });
          }
        );
      } else if (value === "sendInvite") {
        props.sendInviteApiCall(
          {
            ...values,
            Status_Code: 1,
            accountAccessibility: updatedAccountAccessibility,
            Platform_Accessibility: valueRadio,
            Group_Visibility: selectedRows,
            balanceCheckProvider,
          },
          (res) => {
            setLoading(false);
            if (res.status === true) {
              enqueueSnackbar(`${res.message}`, {
                variant: "success",
              });
              props.history.push(`/${props.mainData.app.layout}/Merchant`);
            }
          },
          (err) => {
            setLoading(false);
            enqueueSnackbar(`${err.message}`, {
              variant: "error",
            });
          }
        );
      } else if (value === "resendInvite") {
        props.sendInviteApiCall(
          {
            ...values,
            Resend_Invite: true,
            accountAccessibility: updatedAccountAccessibility,
            Business_OBJid:
              props?.merchantListData?.merchantListData?.data[0]?._id,
            Manager_OBJid:
              props?.merchantListData?.merchantListData?.data[0]
                ?.Manager_Details?._id,
          },
          (res) => {
            setLoading(false);
            if (res.status === true) {
              enqueueSnackbar(`${res.message}`, {
                variant: "success",
              });

              props.history.push(`/${props.mainData.app.layout}/Merchant`);
            }
          },
          (err) => {
            setLoading(false);
            enqueueSnackbar(`${err.message}`, {
              variant: "error",
            });
          }
        );
      }
      setValidationModal(false);
    } else {
      setValidationModal(true);
    }
  };

  const handleErrorMessage = () => {
    setLoading(false);
    setValidationModal(false);
    setErrorMessage(false);
    // setSaveDraftClick(false);
  };
  const handleAssignGroup = () => {
    setAssignGroupsModal(true);
    props.getMerchantGroupCode();
  };

  const onChange = (value, type) => {
    const allState = { ...values };
    const error = { ...validationError };
    error[type] = false;
    if (
      type === "firstName" ||
      type === "lastName" ||
      type === "businessName" ||
      type === "dba"
    ) {
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }
    if (type === "email") {
      value = value.toLowerCase();
    }
    allState[type] = value;
    allState.Manager_id = profileId;
    allState.userId = "";
    if (sameAsMailing) {
      allState.mailingRoom = allState.businessRoom;
      allState.mailingFloor = allState.businessFloor;
      allState.mailingStreet = allState.businessStreet;
      allState.mailingCountry = allState.businessCountry;
      allState.mailingState = allState.businessState;
      allState.mailingCity = allState.businessCity;
      allState.mailingPostalCode = allState.businessPostalCode;
    }

    let accountNumberEdited = false;
    let routingNumberEdited = false;

    if (type === "businessWebsite") {
      const res = value.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
      );
      if (value === "") {
        error[type] = false;
        allState[type] = value;
      } else if (res === null) {
        error[type] = true;
        allState[type] = value;
      } else {
        error[type] = false;
        allState[type] = value;
      }
    }
    if (type === "businessPostalCode") {
      if (!/^[0-9]{5}$/.test(value)) {
        error[type] = true;
        allState[type] = value;
      } else {
        error[type] = false;
        allState[type] = value;
      }
    }
    if (type === "mailingPostalCode") {
      if (!/^[0-9]{5}$/.test(value)) {
        error[type] = true;
        allState[type] = value;
      } else {
        error[type] = false;
        allState[type] = value;
      }
    }
    if (type === "managerPostalCode") {
      if (!/^[0-9]{5}$/.test(value)) {
        error[type] = true;
        allState[type] = value;
      } else {
        error[type] = false;
        allState[type] = value;
      }
    }
    if (type === "accountNumber") {
      accountNumberEdited = true;
      if (value.length < 8 || value.length > 17) {
        error[type] = true;
        allState[type] = value;
      }
      if (value.length === 8) {
        error[type] = false;
        allState[type] = value;
      }
    }
    if (type === "confirmAccountNumber") {
      if (value !== values.accountNumber) {
        error[type] = true;
        allState[type] = value;
      }
      if (value === values.accountNumber) {
        error[type] = false;
        allState[type] = value;
      }
    }
    if (type === "confirmRoutingNumber") {
      if (value !== values.routingNumber) {
        error[type] = true;
        allState[type] = value;
      }
      if (value === values.routingNumber) {
        error[type] = false;
        allState[type] = value;
      }
    }
    if (type === "email") {
      const res = value.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/
      );
      if (res === null) {
        error[type] = true;
        allState[type] = value;
      } else {
        error[type] = false;
        allState[type] = value;
      }
    }
    if (type === "routingNumber") {
      routingNumberEdited = true;
      if (!/^[0-9]{9}$/.test(value)) {
        if (value.length !== 9) {
          error[type] = true;
          allState[type] = value;
        }
        if (value.length === 9) {
          error[type] = false;
          allState[type] = value;
        }
      }
    }
    if (accountNumberEdited) {
      setConfirmAccountNumberVisible(true);
    }
    if (routingNumberEdited) {
      setConfirmRoutingNumberVisible(true);
    }
    if (type === "feeRate") {
      allState.feeRate = value;
      allState.perTransactionFee = "";
      allState.percentageFee = "";
      allState.aboveTransactionValue = "";
      allState.none = "";
    }
    if (type === "feeTypeSurcharge" && value) {
      allState.feeTypeDiscounted = false;
    }
    if (type === "feeTypeDiscounted" && value) {
      allState.feeTypeSurcharge = false;
    }
    if (type === "phoneNumber") {
      const formattedNumber = value.replace(/\D/g, "").slice(0, 10);
      allState[type] = formattedNumber;
    }
    handleInput(allState);
    setVlidationError(error);
  };

  const displayAccountNumber = () => {
    const { accountNumber } = values;
    if (!accountNumber) {
      return "";
    }
    if (isRevealAcn || values?.accountNumber?.length <= 4) {
      return values?.accountNumber;
    }
    const maskedNumber =
      "*".repeat(values?.accountNumber?.length - 4) +
      values?.accountNumber?.slice(-4);
    return maskedNumber;
  };

  const displayConfirmAccountNumber = () => {
    if (isRevealAcnConfirm || values?.confirmAccountNumber?.length <= 4) {
      return values?.confirmAccountNumber;
    }
    const maskedNumber =
      "*".repeat(values?.confirmAccountNumber?.length - 4) +
      values?.confirmAccountNumber?.slice(-4);
    return maskedNumber;
  };

  const handleEditFeeCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    handleInput((prevState) => ({
      ...prevState,
      feeCanNotBeEdited: isChecked,
    }));
  };

  const handleBankDetailsCheckboxChange = (event) => {
    if (!disabled1) {
      const isChecked1 = event.target.checked;
      handleInput((prevState) => ({
        ...prevState,
        bankDetailsCannotBeEdited: isChecked1,
      }));
    }
  };

  const handleSameAsMailingChange = (event) => {
    setSameAsMailing(event.target.checked);
    const isChecked = event.target.checked;
    handleInput((values) => ({
      ...values,
      AddressDetailsChecked: isChecked,
      mailingRoom: values.businessRoom,
      mailingFloor: values.businessFloor,
      mailingStreet: values.businessStreet,
      mailingCountry: values.businessCountry,
      mailingState: values.businessState,
      mailingCity: values.businessCity,
      mailingPostalCode: values.businessPostalCode,
    }));
    if (!event.target.checked) {
      handleInput((prevValues) => ({
        ...prevValues,
        mailingRoom: "",
        mailingFloor: "",
        mailingStreet: "",
        mailingCountry: "",
        mailingState: "",
        mailingCity: "",
        mailingPostalCode: "",
      }));
    }
  };

  const countries = props.formData.countryTypeList?.Country_Data ?? [];

  const clearRoutingNumberData = () => {
    props.emptyMerchantRTNReduxState();
  };

  const clearAccountNumberData = () => {
    props.emptyMerchantAccReduxState();
  };

  const handleBack = () => {
    localStorage.setItem("BackPressed", true);
    props.history.push(`/${props.mainData.app.layout}/MerchantSetup`);
  };
  const achInvalid =
    achValue &&
    (!values.Balance_Check_Provider || values.Balance_Check_Provider.length === 0 ||
      (values.Balance_Check_Provider === "DecisionLogic" && (!values.serviceKey || values.serviceKey === "")));

  const rtpInvalid =
    rtpValue &&
    (
      !values.feeRate
    );

  const hasSelectedService =
    rtpValue ||
    achValue ||
    vikExclude || CPR;

  const sendInviteDisabled =
    !hasSelectedService ||
    (achValue && achInvalid) ||
    (rtpValue && rtpInvalid);
  console.log("sendInviteDisabled", sendInviteDisabled);
  console.log("hasSelectedService", hasSelectedService);
  console.log("CPR", CPR);
  useEffect(() => {
    const filterFiled = profileCode !== profileCodePermissionCheck.profileCode.VCS;
    const filedsDisabled = filterFiled || (values.Status_Code == 1 && values.Status_Code !== "") || (values.Status_Code == 3 && values.Status_Code !== "");
    setFiledDisabled(filedsDisabled);
  }, [profileCode, values.Status_Code]);
  const managerStatus =
    props?.merchantListData?.merchantListData?.data?.[0]?.ManagerStatus?.Status;

  const isEditMerchant = Array.isArray(managerStatus);

  const availableServices = managerStatus || [];

  const serviceExists = (serviceCode) =>
    availableServices.some(
      (service) => service.Service_Code === serviceCode
    );

  return (
    <div style={{ paddingBottom: "40px" }}>
      {/* Loader component to show loading state */}
      <AppLoader loader={loading} />
      {/* Validation Modal */}
      <Modal open={validationModal} onClose={() => setValidationModal(false)}>
        <div className={classes.modalDiv}>
          <Card
            style={{
              width: "50%",
              maxWidth: "40%",
              height: "auto",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                minInlineSize: "-webkit-fill-available",
                textAlign: "start",
                height: "auto",
                maxHeight: "70vh",
                display: "flex",
                overflow: "auto",
                flexWrap: "nowrap",
                marginTop: "10%",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {/* Close image */}
              <img
                src={closeImage}
                style={{ width: "10%", marginBottom: "3%" }}
                alt=""
              />
              <div className={classes.successText}>
                {/* Error message */}
                {!errorMessage ? (
                  <Typography
                    style={{ textAlign: "center" }}
                    color="error"
                    variant="subtitle2"
                    gutterBottom
                  >
                    Please correct all validation errors before proceeding. Note
                    the highlighted fields.
                  </Typography>
                ) : (
                  ""
                )}
              </div>
              {/* Display error messages if any */}
              {errorMessage && (
                <div
                  style={{ marginTop: "2%" }}
                  className={classes.successText}
                >
                  {errorMessage &&
                    errorMessage.map((key) => (
                      <div className={classes.successText}>
                        -{` ${key.msg}`}{" "}
                      </div>
                    ))}
                </div>
              )}
              <br />
            </div>

            {/* Modal actions */}
            <CardActions style={{ margin: "5%" }}>
              <Button
                variant="contained"
                className={classes.buttonStyle}
                color="#696969"
                size="sm"
                onClick={() => handleErrorMessage()}
              >
                Ok
              </Button>
            </CardActions>
          </Card>
        </div>
      </Modal>

      {/* Assign Groups Modal */}
      <Modal open={assignGroupsModal}>
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            height: "100%",
            width: "30%", // Adjust width as needed
            backgroundColor: "white",
            boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.5)",
            zIndex: 1300,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          {/* Loader for Assign Groups */}
          {/* <LoaderSignUp loader={loadingDialog} /> */}
          <CardActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* Close button */}
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
            <Typography
              style={{
                marginBottom: "10px",
                fontWeight: "600",
                paddingRight: "10px",
              }}
            >
              Selected: {selectedRows?.length} / {tableData?.length}
            </Typography>
          </CardActions>

          {/* Table for Assign Groups */}
          <Card
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              margin: "0px",
            }}
          >
            <TableContainer component={Paper} style={{ maxHeight: "90vh" }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      {/* Select All Checkbox */}
                      <Checkbox
                        color="primary"
                        indeterminate={
                          selectedRows?.length > 0 &&
                          selectedRows?.length < tableData?.length
                        }
                        checked={isAllSelected}
                        onChange={(e) => {
                          handleSelectAll(e);
                          setSubmitDisabled(false);
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <strong>Name</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Render table rows */}
                  {tableData?.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={selectedRows.some(
                            (item) => item.id === row.id
                          )}
                          onChange={() => {
                            setSubmitDisabled(false);
                            handleCheckboxChange(row);
                          }}
                        />
                      </TableCell>
                      <TableCell>{row.name}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </div>
      </Modal>

      {/* Business Details Section */}
      <Box
        style={{
          alignItems: "center",
          marginTop: "30px",
        }}
        className={classes.tittleColor}
        height={40}
      >
        <Typography className={classes.tittleTextColor}>
          Business Details
        </Typography>
      </Box>
      {/* Business Details Form */}
      <Box className={classes.marginBox}>
        <Grid container className={classes.margin}>
          {/* Business Name Field */}
          <Grid item lg={4} sm={6} xs={12}>
            <BusinessCenterIcon className={classes.inputBox} fontSize="small" />
            <TextField
              required
              error={validationError.businessName}
              className={classes.root}
              inputlabelprops={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip
                      title="As it appear on your income tax return"
                      placement="top"
                    >
                      <HelpOutlineOutlinedIcon
                        // classes={{
                        //   root: "HelpIcon",
                        //   icon: "withHelpOutline",
                        // }}
                        color="action"
                        fontSize="small"
                      />
                    </Tooltip>
                  </InputAdornment>
                ),
                classes: {
                  root: classes.activeInputColor,
                  focused: "focused",
                  input: classes.resize,
                },
                required: true,
              }}
              label="Business Name"
              value={values.businessName ?? ""}
              helperText={
                validationError.businessName && "Business Name is required."
              }
              onChange={(e) => {
                const value = e.target.value;

                setSubmitDisabled(false);

                if (/^[A-Za-z0-9.\-/&,\s]*$/.test(value) || value === "") {
                  onChange(value, "businessName");
                }
              }}
              disabled={filedsDisabled}
              name="businessName"
              id="businessName"
            />
          </Grid>
          <Grid item lg={4} sm={6} xs={12}>
            <PersonIcon className={classes.inputBox} fontSize="small" />
            <TextField
              required
              error={validationError.dba}
              className={classes.root}
              inputlabelprops={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  focused: "focused",
                  input: classes.resize,
                },
              }}
              label="DBA Name"
              value={values.dba ?? ""}
              disabled={filedsDisabled}
              onChange={(e) => {
                const value = e.target.value;
                const isValid =
                  /^[A-Za-z0-9.\-/&,\s]*$/.test(value) || value === "";

                if (isValid) {
                  onChange(value, "dba");
                }

                setSubmitDisabled(false);
              }}
              name="dba"
              id="dba"
              helperText={validationError.dba && "Provide Legal DBA Name"}
            />
          </Grid>
          <Grid item lg={4} sm={6} xs={12}>
            <WebIcon className={classes.inputBox} fontSize="small" />
            <TextField
              className={classes.root}
              inputlabelprops={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  input: classes.resize,
                  focused: "focused",
                },
              }}
              label="Website Url"
              error={validationError.businessWebsite}
              value={values.businessWebsite ?? ""}
              onChange={(e) => {
                setSubmitDisabled(false);
                onChange(e.target.value, "businessWebsite");
              }}
              disabled={filedsDisabled}
              name="businessWebsite"
              id="businessWebsite"
              helperText={
                validationError.businessWebsite &&
                "please enter a valid web url"
              }
            />
          </Grid>
          <Grid item lg={4} sm={6} xs={12}>
            <AccountBalanceIcon className={classes.inputBox} fontSize="small" />
            <TextField
              className={classes.root}
              inputlabelprops={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  input: classes.resize,
                  focused: "focused",
                },
                inputProps: { maxLength: 50 },
              }}
              label="Business Description"
              error={validationError.bsinessDescription}
              value={values.bsinessDescription ?? ""}
              onChange={(e) => {
                setSubmitDisabled(false);
                onChange(e.target.value, "bsinessDescription");
              }}
              disabled={filedsDisabled}
              name="bsinessDescription"
              id="bsinessDescription"
              helperText={
                validationError.bsinessDescription &&
                "please enter a valid description"
              }
            />
          </Grid>

          {values.uid && (
            <Grid
              item
              lg={4}
              sm={6}
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                color: "#696969",
              }}
              className={classes.activeInputLabelColor}
            >
              <BusinessCenterIcon
                className={classes.inputBox}
                fontSize="small"
              />
              <Typography>Business UID :{values.uid ?? ""} </Typography>
            </Grid>
          )}
        </Grid>
        <Divider style={{ marginTop: "20px", marginBottom: "10px" }} />
      </Box>
      <Box
        style={{
          alignItems: "center",
          marginTop: "30px",
        }}
        className={classes.tittleColor}
        height={40}
      >
        <Typography className={classes.tittleTextColor}>
          Address Details
        </Typography>
      </Box>
      <div
        style={{
          margin: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          alignContent: "center",
          textAlign: "center",
        }}
      >
        <div>
          <Typography className={classes.ownerTittle}>
            <b>Business Address</b>
          </Typography>
        </div>
      </div>
      <Grid container className={classes.margin}>
        <Grid item lg={4} sm={6} xs={3}>
          <LocationCityRoundedIcon
            className={classes.inputBox}
            fontSize="small"
          />
          <TextField
            className={classes.root}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
              inputProps: { maxLength: 50 },
            }}
            label="Room"
            error={validationError.businessRoom}
            value={values.businessRoom ?? ""}
            onChange={(e) => {
              setSubmitDisabled(false);
              onChange(e.target.value, "businessRoom");
            }}
            // disabled={filedsDisabled}
            helperText={
              validationError.businessRoom && "Please enter a valid value."
            }
            name="businessRoom"
            id="businessRoom"
          />
        </Grid>
        <Grid item lg={4} sm={6} xs={3}>
          <LocationCityRoundedIcon
            className={classes.inputBox}
            fontSize="small"
          />
          <TextField
            className={classes.root}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
              inputProps: { maxLength: 50 },
            }}
            label="Floor"
            error={validationError.businessFloor}
            value={values.businessFloor ?? ""}
            onChange={(e) => {
              setSubmitDisabled(false);
              onChange(e.target.value, "businessFloor");
            }}
            // disabled={filedsDisabled}
            helperText={
              validationError.businessFloor && "Please enter a valid value."
            }
            name="businessFloor"
            id="businessFloor"
          />
        </Grid>
        <Grid item lg={4} sm={6} xs={3}>
          <LocationCityRoundedIcon
            className={classes.inputBox}
            fontSize="small"
          />
          <TextField
            required
            className={classes.root}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
              inputProps: { maxLength: 50 },
            }}
            label="Street Name"
            error={validationError.businessStreet}
            value={countries?.length ? values.businessStreet : ""}
            onChange={(e) => {
              setSubmitDisabled(false);
              onChange(e.target.value, "businessStreet");
            }}
            // disabled={filedsDisabled}
            helperText={
              validationError.businessStreet && "Business Street is required."
            }
            name="businessStreet"
            id="businessStreet"
          />
        </Grid>
        <Grid item lg={4} sm={6} xs={3}>
          <PublicIcon className={classes.inputBox} fontSize="small" />
          <TextField
            required
            className={classes.root}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
            }}
            label="Country"
            value={values.businessCountry ?? ""}
            error={validationError.businessCountry}
            onChange={(e) => {
              setSubmitDisabled(false);
              onChange(e.target.value, "businessCountry");
            }}
            // disabled={filedsDisabled}
            helperText={
              validationError.businessCountry && "Business Country is required."
            }
            name="businessCountry"
            id="businessCountry"
            select
          >
            {props.formData.countryTypeList && props.formData.countryTypeList ? countries.map((key) => [
              <MenuItem
                key={key.Country_Code}
                className={classes.dialogBoxDropDown}
                value={key.Country_Code}
              >
                {key.Country_Name}
              </MenuItem>,
            ]) : <MenuItem value="">
              Loading...
            </MenuItem>}
          </TextField>
        </Grid>
        <Grid item lg={4} sm={6} xs={3}>
          <NearMeRoundedIcon className={classes.inputBox} fontSize="small" />
          {values.businessCountry === "US" ? (
            <TextField
              required
              className={classes.root}
              inputlabelprops={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  input: classes.resize,
                  focused: "focused",
                },
              }}
              // disabled={filedsDisabled}
              label="State"
              value={values.businessState ?? ""}
              error={validationError.businessState}
              onChange={(e) => {
                setSubmitDisabled(false);
                onChange(e.target.value, "businessState");
              }}
              helperText={
                validationError.businessState && "Business State is required."
              }
              name="businessState"
              id="businessState"
              select
            >
              {locationCity
                ?.sort((a, b) => (a.name > b.name ? 1 : -1))
                ?.map((key) => [
                  <MenuItem
                    key={key.value}
                    className={classes.dialogBoxDropDown}
                    value={key.value}
                  >
                    {key.name}
                  </MenuItem>,
                ])}
            </TextField>
          ) : (
            <TextField
              required
              // disabled={filedsDisabled}
              className={classes.root}
              inputlabelprops={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  input: classes.resize,
                  focused: "focused",
                },
              }}
              label="State"
              error={validationError.businessState ?? ""}
              value={values.businessState}
              onChange={(e) => onChange(e.target.value, "businessState")}
              helperText={
                validationError.businessState && "Business State is required."
              }
              name="businessState"
              id="businessState"
            />
          )}
        </Grid>
        <Grid item lg={4} sm={6} xs={3}>
          <LocationCityRoundedIcon
            className={classes.inputBox}
            fontSize="small"
          />
          <TextField
            required
            className={classes.root}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
            }}
            label="City"
            error={validationError.businessCity}
            value={values.businessCity ?? ""}
            onChange={(e) => {
              setSubmitDisabled(false);
              onChange(e.target.value, "businessCity");
            }}
            // disabled={filedsDisabled}
            helperText={
              validationError.businessCity && "Business City is required."
            }
            name="businessCity"
            id="businessCity"
          />
        </Grid>
        <Grid item lg={4} sm={6} xs={3}>
          <RoomIcon className={classes.inputBox} fontSize="small" />
          <TextField
            required
            style={{
              width: windowWidthLG ? "74%" : "80%",
              "&.focused": {
                color: theme.palette.primary.main,
                fontSize: "14px",
                fontStyle: "Helvetica, Arial,sans-serif",
              },
            }}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              inputProps: { min: 0 },
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
            }}
            label="Postal Code"
            error={validationError.businessPostalCode}
            value={values.businessPostalCode ?? ""}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[0-9]\d*$/.test(value) || value === "") {
                onChange(value, "businessPostalCode");
              }
              setSubmitDisabled(false);
            }}
            // disabled={filedsDisabled}
            helperText={
              validationError.businessPostalCode &&
              "5 Digit Business Postal Code is required."
            }
            name="businessPostalCode"
            id="businessPostalCode"
            type="text"
          />
        </Grid>
        <Grid item lg={12} sm={6} xs={3}>
          <FormControlLabel
            control={(
              <Checkbox
                checked={sameAsMailing}
                onChange={handleSameAsMailingChange}
                color="primary"
              />
            )}
            label="Mailing address is same as business address"
          />
        </Grid>
        {!sameAsMailing && (
          <>
            <div
              style={{
                margin: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                alignContent: "center",
                textAlign: "center",
              }}
            >
              <div>
                <Typography className={classes.ownerTittle}>
                  <b>Mailing Address</b>
                </Typography>
              </div>
            </div>
            <Grid container className={classes.margin}>
              <Grid item lg={4} sm={6} xs={3}>
                <LocationCityRoundedIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <TextField
                  className={classes.root}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                    inputProps: { maxLength: 50 },
                  }}
                  label="Room"
                  error={validationError.mailingRoom}
                  value={values.mailingRoom ?? ""}
                  onChange={(e) => {
                    setSubmitDisabled(false);
                    onChange(e.target.value, "mailingRoom");
                  }}
                  // disabled={
                  //   filedsDisabled
                  // }
                  helperText={
                    validationError.mailingRoom && "Please enter a valid value."
                  }
                  name="mailingRoom"
                  id="mailingRoom"
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={3}>
                <LocationCityRoundedIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <TextField
                  className={classes.root}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                    inputProps: { maxLength: 50 },
                  }}
                  label="Floor"
                  error={validationError.mailingFloor}
                  value={values.mailingFloor ?? ""}
                  onChange={(e) => {
                    setSubmitDisabled(false);
                    onChange(e.target.value, "mailingFloor");
                  }}
                  // disabled={
                  //   filedsDisabled
                  // }
                  helperText={
                    validationError.mailingFloor &&
                    "Please enter a valid value."
                  }
                  name="mailingFloor"
                  id="mailingFloor"
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={3}>
                <LocationCityRoundedIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <TextField
                  required={!values.AddressDetailsChecked}
                  className={classes.root}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                    inputProps: { maxLength: 50 },
                  }}
                  label="Street Name"
                  error={validationError.mailingStreet}
                  value={values.mailingStreet ?? ""}
                  onChange={(e) => {
                    setSubmitDisabled(false);
                    onChange(e.target.value, "mailingStreet");
                  }}
                  helperText={
                    validationError.mailingStreet &&
                    "Mailing Street is required."
                  }
                  // disabled={
                  //   filedsDisabled
                  // }
                  name="mailingStreet"
                  id="mailingStreet"
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={3}>
                <PublicIcon className={classes.inputBox} fontSize="small" />
                <TextField
                  required={!values.AddressDetailsChecked}
                  className={classes.root}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  // disabled={
                  //   filedsDisabled
                  // }
                  label="Country"
                  value={countries?.length ? values.mailingCountry : ""}
                  error={validationError.mailingCountry}
                  onChange={(e) => {
                    setSubmitDisabled(false);
                    onChange(e.target.value, "mailingCountry");
                  }}
                  helperText={
                    validationError.mailingCountry &&
                    "Mailing Country is required."
                  }
                  name="mailingCountry"
                  id="mailingCountry"
                  select
                >
                  {props.formData.countryTypeList &&
                    props.formData.countryTypeList ?
                    countries?.map((key) => (
                      <MenuItem
                        key={key.Country_Code}
                        className={classes.dialogBoxDropDown}
                        value={key.Country_Code}
                      >
                        {key.Country_Name}
                      </MenuItem>
                    )) : <MenuItem value="">
                      Loading...
                    </MenuItem>}
                </TextField>
              </Grid>
              <Grid item lg={4} sm={6} xs={3}>
                <NearMeRoundedIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                {values.mailingCountry === "US" ? (
                  <TextField
                    required={!values.AddressDetailsChecked}
                    className={classes.root}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLableColor,
                        focused: "focused",
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.activeInputColor,
                        input: classes.resize,
                        focused: "focused",
                      },
                    }}
                    // disabled={
                    //   filedsDisabled
                    // }
                    label="State"
                    value={values.mailingState ?? ""}
                    error={validationError.mailingState}
                    onChange={(e) => {
                      setSubmitDisabled(false);
                      onChange(e.target.value, "mailingState");
                    }}
                    helperText={
                      validationError.mailingState &&
                      "Mailing State is required."
                    }
                    name="mailingState"
                    id="mailingState"
                    select
                  >
                    {locationCity
                      ?.sort((a, b) => (a.name > b.name ? 1 : -1))
                      ?.map((key) => (
                        <MenuItem
                          key={key.value}
                          className={classes.dialogBoxDropDown}
                          value={key.value}
                        >
                          {key.name}
                        </MenuItem>
                      ))}
                  </TextField>
                ) : (
                  <TextField
                    required={!values.AddressDetailsChecked}
                    className={classes.root}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLableColor,
                        focused: "focused",
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.activeInputColor,
                        input: classes.resize,
                        focused: "focused",
                      },
                    }}
                    // disabled={
                    //   filedsDisabled
                    // }
                    label="State"
                    error={validationError.mailingState}
                    value={values.mailingState ?? ""}
                    onChange={(e) => onChange(e.target.value, "mailingState")}
                    helperText={
                      validationError.mailingState &&
                      "Mailing State is required."
                    }
                    name="mailingState"
                    id="mailingState"
                  />
                )}
              </Grid>
              <Grid item lg={4} sm={6} xs={3}>
                <LocationCityRoundedIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <TextField
                  required={!values.AddressDetailsChecked}
                  className={classes.root}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  label="City"
                  error={validationError.mailingCity}
                  value={values.mailingCity ?? ""}
                  onChange={(e) => {
                    setSubmitDisabled(false);
                    onChange(e.target.value, "mailingCity");
                  }}
                  // disabled={
                  //   filedsDisabled
                  // }
                  helperText={
                    validationError.mailingCity && "Mailing City is required."
                  }
                  name="mailingCity"
                  id="mailingCity"
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={3}>
                <RoomIcon className={classes.inputBox} fontSize="small" />
                <TextField
                  required={!values.AddressDetailsChecked}
                  style={{
                    width: windowWidthLG ? "74%" : "80%",
                    "&.focused": {
                      color: theme.palette.primary.main,
                      fontSize: "14px",
                      fontStyle: "Helvetica, Arial,sans-serif",
                    },
                  }}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  label="Postal Code"
                  error={validationError.mailingPostalCode}
                  value={values.mailingPostalCode ?? ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[0-9]\d*$/.test(value) || value === "") {
                      onChange(value, "mailingPostalCode");
                    }
                    setSubmitDisabled(false);
                  }}
                  // disabled={
                  //   filedsDisabled
                  // }
                  helperText={
                    validationError.mailingPostalCode &&
                    "5 Digit Mailing Postal Code is required."
                  }
                  name="mailingPostalCode"
                  id="mailingPostalCode"
                  type="text"
                />
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
      <Divider style={{ marginTop: "20px", marginBottom: "10px" }} />
      <Box
        style={{
          alignItems: "center",
          marginTop: "30px",
        }}
        className={classes.tittleColor}
        height={40}
        marginBottom="10px"
      >
        <Typography className={classes.tittleTextColor}>
          Primary Manager Details
        </Typography>
      </Box>
      <Grid container className={classes.margin}>
        <Grid item lg={4} sm={6} xs={12}>
          <Box style={{ display: "flex" }}>
            <StayCurrentPortraitIcon
              className={classes.inputBox}
              fontSize="small"
            />
            <EmailAutofill
              email={values.email}
              onEmailChange={handleEmailChange}
              agentsList={props?.merchantListData?.emailListData?.data || []}
              selectedUser={selectedUser}
              setSelectedUser={handleUserSelect}
              allowManualInput={!props?.merchantListData?.emailData}
              emailError={validationError.email}
              setEmailError={(error) =>
                setVlidationError((prevError) => ({
                  ...prevError,
                  email: error,
                }))
              }
              values={values}
            />
          </Box>
          {props?.merchantListData?.emailData?.Mg_Status === "Not Active" &&
            id == null ? (
            <Typography
              style={{
                paddingTop: "5px",
                paddingBottom: "5px",
                paddingLeft: "41px",
                color: "red",
              }}
            >
              This manager must complete signup for their previous business
              before being invited to a new one.
            </Typography>
          ) : (
            ""
          )}
        </Grid>
        <Grid item lg={4} sm={6} xs={12}>
          <PersonIcon className={classes.inputBox} fontSize="small" />
          <TextField
            required
            error={validationError.firstName}
            className={classes.root}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
              required: true,
            }}
            label="First Name"
            value={values.firstName ?? ""}
            onChange={(e) => {
              onChange(e.target.value, "firstName");
            }}
            // disabled={filedsDisabled}
            helperText={
              validationError.firstName &&
              "First Name is required and cannot start with a number."
            }
            name="firstName"
            id="firstName"
          />
        </Grid>
        <Grid item lg={4} sm={6} xs={12}>
          <PersonIcon className={classes.inputBox} fontSize="small" />
          <TextField
            className={classes.root}
            error={validationError.lastName}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            required
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
              required: true,
            }}
            label="Last Name"
            value={values.lastName ?? ""}
            // disabled={filedsDisabled}
            onChange={(e) => {
              onChange(e.target.value, "lastName");
            }}
            helperText={
              validationError.lastName &&
              "Last Name is required and cannot start with a number."
            }
            name="lastName"
            id="lastName"
          />
        </Grid>
        <Grid item lg={4} sm={6} xs={12}>
          <StayCurrentPortraitIcon
            className={classes.inputBox}
            fontSize="small"
          />
          <TextField
            disabled={
              // (filedsDisabled) ||
              profileCode === profileCodePermissionCheck.profileCode.SA
            }
            className={classes.root}
            required
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
            }}
            label="Phone"
            helperText={
              validationError.phoneNumber &&
              "Enter a Valid Phone Number with 10 Digits Only"
            }
            error={validationError.phoneNumber}
            value={formatPhoneNumber(values.phoneNumber ?? "")}
            onChange={(e) => {
              const formattedNumber = e.target.value
                .replace(/\D/g, "")
                .slice(0, 10);
              onChange(formattedNumber, "phoneNumber");
            }}
            name="phoneNumber"
            id="phoneNumber"
            type="text"
          />
        </Grid>

        <Grid item lg={4} sm={6} xs={3}>
          <LocationCityRoundedIcon
            className={classes.inputBox}
            fontSize="small"
          />
          <TextField
            className={classes.root}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
              inputProps: { maxLength: 50 },
            }}
            // disabled={filedsDisabled}
            label="Room"
            error={validationError.managerRoom}
            value={values.managerRoom ?? ""}
            onChange={(e) => {
              onChange(e.target.value, "managerRoom");
            }}
            helperText={
              validationError.managerRoom && "Please enter a valid value."
            }
            name="managerRoom"
            id="managerRoom"
          />
        </Grid>
        <Grid item lg={4} sm={6} xs={3}>
          <LocationCityRoundedIcon
            className={classes.inputBox}
            fontSize="small"
          />
          <TextField
            className={classes.root}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
              inputProps: { maxLength: 50 },
            }}
            // disabled={filedsDisabled}
            label="Floor"
            error={validationError.managerFloor}
            value={values.managerFloor ?? ""}
            onChange={(e) => {
              onChange(e.target.value, "managerFloor");
            }}
            helperText={
              validationError.managerFloor && "Please enter a valid value."
            }
            name="managerFloor"
            id="managerFloor"
          />
        </Grid>
        <Grid item lg={4} sm={6} xs={3}>
          <LocationCityRoundedIcon
            className={classes.inputBox}
            fontSize="small"
          />
          <TextField
            required
            className={classes.root}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
              inputProps: { maxLength: 50 },
            }}
            // disabled={filedsDisabled}
            label="Street Name"
            error={validationError.managerStreet}
            value={values.managerStreet ?? ""}
            onChange={(e) => {
              onChange(e.target.value, "managerStreet");
            }}
            helperText={validationError.managerStreet && "Street is required."}
            name="managerStreet"
            id="managerStreet"
          />
        </Grid>
        <Grid item lg={4} sm={6} xs={3}>
          <PublicIcon className={classes.inputBox} fontSize="small" />
          <TextField
            required
            // disabled={filedsDisabled}
            className={classes.root}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
            }}
            label="Country"
            value={countries?.length ? values.managerCountry : ""}
            error={validationError.managerCountry}
            onChange={(e) => {
              onChange(e.target.value, "managerCountry");
            }}
            helperText={validationError.managerCountry && "Country is required."}
            name="managerCountry"
            id="managerCountry"
            select
          >
            {props.formData.countryTypeList ?
              countries?.map((key) => (
                <MenuItem
                  key={key.Country_Code}
                  className={classes.dialogBoxDropDown}
                  value={key.Country_Code}
                >
                  {key.Country_Name}
                </MenuItem>
              )) : <MenuItem value="">
                Loading...
              </MenuItem>}
          </TextField>
        </Grid>
        <Grid item lg={4} sm={6} xs={3}>
          <NearMeRoundedIcon className={classes.inputBox} fontSize="small" />
          {values.managerCountry === "US" ? (
            <TextField
              required
              className={classes.root}
              inputlabelprops={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              // disabled={filedsDisabled}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  input: classes.resize,
                  focused: "focused",
                },
              }}
              label="State"
              value={values.managerState ?? ""}
              error={validationError.managerState}
              onChange={(e) => {
                onChange(e.target.value, "managerState");
              }}
              helperText={
                validationError.managerState && "Please enter correct  state."
              }
              name="managerState"
              id="managerState"
              select
            >
              {locationCity
                ?.sort((a, b) => (a.name > b.name ? 1 : -1))
                ?.map((key) => (
                  <MenuItem
                    key={key.value}
                    className={classes.dialogBoxDropDown}
                    value={key.value}
                  >
                    {key.name}
                  </MenuItem>
                ))}
            </TextField>
          ) : (
            <TextField
              required
              className={classes.root}
              inputlabelprops={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  input: classes.resize,
                  focused: "focused",
                },
              }}
              label="State"
              error={validationError.managerState}
              value={values.managerState ?? ""}
              // disabled={filedsDisabled}
              onChange={(e) => {
                onChange(e.target.value, "managerState");
              }}
              helperText={validationError.managerState && "State is required."}
              name="managerState"
              id="managerState"
            />
          )}
        </Grid>
        <Grid item lg={4} sm={6} xs={3}>
          <LocationCityRoundedIcon
            className={classes.inputBox}
            fontSize="small"
          />
          <TextField
            required
            // disabled={filedsDisabled}
            className={classes.root}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
            }}
            label="City"
            error={validationError.managerCity}
            value={values.managerCity ?? ""}
            onChange={(e) => {
              onChange(e.target.value, "managerCity");
            }}
            helperText={validationError.managerCity && "City is required."}
            name="managerCity"
            id="managerCity"
          />
        </Grid>
        <Grid item lg={4} sm={6} xs={3}>
          <RoomIcon className={classes.inputBox} fontSize="small" />
          <TextField
            required
            style={{
              width: windowWidthLG ? "74%" : "80%",
              "&.focused": {
                color: theme.palette.primary.main,
                fontSize: "14px",
                fontStyle: "Helvetica, Arial,sans-serif",
              },
            }}
            inputlabelprops={{
              classes: {
                root: classes.activeInputLableColor,
                focused: "focused",
              },
            }}
            InputProps={{
              inputProps: { min: 0 },
              classes: {
                root: classes.activeInputColor,
                input: classes.resize,
                focused: "focused",
              },
              required: true,
            }}
            label="Postal Code"
            error={validationError.managerPostalCode}
            value={values.managerPostalCode ?? ""}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[0-9]\d*$/.test(value) || value === "") {
                onChange(value, "managerPostalCode");
              }
            }}
            // disabled={filedsDisabled}
            helperText={
              validationError.managerPostalCode &&
              "5 Digit Postal Code is required."
            }
            name="managerPostalCode"
            id="managerPostalCode"
            type="text"
          />
        </Grid>
        <Grid item lg={4} sm={6} xs={6}>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <AltRouteIcon className={classes.inputBox} fontSize="small" />
            <FormLabel
              style={{
                paddingRight: "36px",
                paddingTop: "6px",
              }}
              component="span"
              id="demo-controlled-radio-buttons-group"
            >
              Platform
            </FormLabel>
            <RadioGroup
              row
              style={{
                paddingTop: "6px",
              }}
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={valueRadio}
              onChange={(e) => handleChangeRadio(e.target.value)}
            >
              <FormControlLabel value="WEB" control={<Radio />} label="WEB" />
              <FormControlLabel
                disabled
                value="api"
                control={<Radio />}
                label="API"
              />
            </RadioGroup>
          </Box>
        </Grid>
      </Grid>

      <Divider style={{ marginTop: "20px", marginBottom: "10px" }} />
      <Grid
        container
        style={{ justifyContent: "center", margin: "20px 0" }}
        className={classes.margin}
      >
        <Grid item lg={12} sm={6} xs={3}>
          <Box
            style={{
              alignItems: "center",
              marginTop: "30px",
            }}
            className={classes.tittleColor}
            height={40}
          >
            <Typography className={classes.tittleTextColor}>
              Services Subscribed
            </Typography>
          </Box>
          <Box
            style={{
              textAlign: "center",
              marginTop: "10px",
              justifyContent: "inherit",
              flexWrap: smallDevice ? "wrap" : "nowrap",
            }}
          >
            {props?.achRtpList &&
              props?.achRtpList?.data
                ?.filter((row) => {
                  // New Merchant (Invite page)
                  if (!isEditMerchant) {
                    return true;
                  }

                  // Existing Merchant
                  return serviceExists(row.Service_Code);
                })
                .map((row, index) => (
                  <FormControlLabel
                    key={index}
                    control={(
                      <Checkbox
                        disabled={
                          filedsDisabled
                        }
                        checked={accountAccessibility.some(
                          (item) => item.Service_Code === row.Service_Code && item.Status !== "Inactive"
                        )}
                        onChange={(event) => {
                          setSubmitDisabled(false);
                          handleCheckboxChangeRtpAch(event, row.Service_Code);
                        }}
                        color="primary"
                      />
                    )}
                    style={{
                      color: "#454545",
                    }}
                    label={`${row?.ServiceName}`}
                  />
                ))}
          </Box>
        </Grid>
      </Grid>
      {rtpValue && (
        <>
          <Box
            style={{
              alignItems: "center",
              marginTop: "30px",
            }}
            className={classes.tittleColor}
            height={40}
          >
            <Typography className={classes.tittleTextColor}>
              Banking Details
            </Typography>
          </Box>
          <Box className={classes.marginBox}>
            <Grid container className={classes.margin}>
              <Grid item lg={6} sm={3} xs={12}>
                <AccountBalanceIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <TextField
                  disabled={filedsDisabled ? filedsDisabled :
                    (profileCode ===
                      profileCodePermissionCheck.profileCode.SA &&
                      props?.merchantListData?.merchantListData &&
                      props?.merchantListData?.merchantListData?.data[0]
                        ?.Banking_Details?.bankDetailsCannotBeEdited) ||
                    (profileCode ===
                      profileCodePermissionCheck.profileCode.VCS &&
                      values.Status_Code !== 1 &&
                      values.Status_Code !== "")
                  }
                  required={rtpValue === true}
                  className={classes.quaterInput}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  onPaste={(e) => e.preventDefault()}
                  onCopy={(e) => e.preventDefault()}
                  label="Routing Number"
                  error={validationError.routingNumber}
                  value={values.routingNumber ?? ""}
                  onChange={(e) => {
                    setSubmitDisabled(false);
                    const routingNumber = e.target.value;
                    const confirmRoutingNumber = values.confirmRoutingNumber;
                    if (e.target.value.length === 9) {
                      const data = {
                        routingNumber: e.target.value,
                        Module_Name:
                          profileCode ===
                            profileCodePermissionCheck.profileCode.VCS
                            ? "Invite Page"
                            : "Merchant Submit Page",
                        Module_Code:
                          profileCode ===
                            profileCodePermissionCheck.profileCode.VCS
                            ? 1
                            : 2,
                        Business_uid: values.uid,
                        Business_Name: values.businessName,
                        Requested_for_id: values?.Requested_for_id,
                        Requested_by_id: values?.Requested_by_id,
                        Manager_id: values?.Manager_id,
                        Manager_Name: `${values.firstName}${values.lastName}`,
                      };
                      props.getRoutingNumberData(data);
                    }
                    if (e.target.value.length !== 9) {
                      clearRoutingNumberData();
                    }
                    if (
                      /^[0-9]\d*$/g.test(e.target.value) ||
                      e.target.value === ""
                    ) {
                      onChange(e.target.value, "routingNumber");
                      if (props.accountNumberData?.status === false) {
                        clearAccountNumberData();
                      }
                    }
                    if (
                      values.accountNumber !== "" &&
                      values.confirmAccountNumber !== "" &&
                      values.accountNumber !== null &&
                      values.confirmAccountNumber !== null &&
                      routingNumber === confirmRoutingNumber &&
                      values.accountNumber === values.confirmAccountNumber &&
                      routingNumber.length === 9
                    ) {
                      const data = {
                        routingNumber,
                        accountNumber: values.accountNumber,
                      };
                      props.getAccountNumberData(data);
                    } else if (
                      values.Status_Code === 1 ||
                      values.Status_Code === 4
                    ) {
                      if (
                        values.accountNumber !== "" &&
                        values.accountNumber !== null &&
                        routingNumber === confirmRoutingNumber &&
                        routingNumber.length === 9
                      ) {
                        const data = {
                          routingNumber,
                          accountNumber: values.accountNumber,
                        };
                        props.getAccountNumberData(data);
                      }
                    }
                  }}
                  helperText={
                    validationError.routingNumber &&
                      values?.routingNumber?.length !== 9
                      ? "9 Digit Routing Number is Required."
                      : null
                  }
                  name="routingNumber"
                  id="routingNumber"
                  type="text"
                />
                <Typography style={{ paddingLeft: "38px", color: "#e67452" }}>
                  {props.routingNumberData && props?.routingNumberData?.network}
                  &nbsp;&nbsp;
                  {props.routingNumberData &&
                    props?.routingNumberData?.rdfi_name}
                  {props.routingNumberData &&
                    !props?.routingNumberData?.available && "This routing number is not supported"}
                </Typography>
              </Grid>
              {confirmRoutingNumberVisible && (
                <Grid item lg={6} sm={3} xs={12}>
                  <AccountBalanceIcon
                    className={classes.inputBox}
                    fontSize="small"
                  />
                  <TextField
                    disabled={filedsDisabled ? filedsDisabled :
                      (profileCode ===
                        profileCodePermissionCheck.profileCode.SA &&
                        props?.merchantListData?.merchantListData &&
                        props?.merchantListData?.merchantListData?.data[0]
                          ?.Banking_Details?.bankDetailsCannotBeEdited) ||
                      (profileCode ===
                        profileCodePermissionCheck.profileCode.VCS &&
                        values.Status_Code !== 1 &&
                        values.Status_Code !== "")
                    }
                    required={values.routingNumber !== ""}
                    className={classes.quaterInput}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLableColor,
                        focused: "focused",
                      },
                    }}
                    InputProps={{
                      inputProps: { min: 0 },
                      classes: {
                        root: classes.activeInputColor,
                        input: classes.resize,
                        focused: "focused",
                      },
                    }}
                    onPaste={(e) => e.preventDefault()}
                    onCopy={(e) => e.preventDefault()}
                    label="Confirm Routing Number"
                    error={
                      validationError.confirmRoutingNumber &&
                      (values.confirmRoutingNumber === "" ||
                        values.confirmRoutingNumber !== values.routingNumber)
                    }
                    onChange={(e) => {
                      setSubmitDisabled(false);
                      const confirmRoutingNumber = e.target.value;
                      const routingNumber = values.routingNumber;
                      if (
                        /^[0-9]\d*$/g.test(e.target.value) ||
                        e.target.value === ""
                      ) {
                        onChange(e.target.value, "confirmRoutingNumber");
                        if (props.accountNumberData?.status === false) {
                          clearAccountNumberData();
                        }
                      }
                      if (
                        values.accountNumber !== "" &&
                        values.confirmAccountNumber !== "" &&
                        values.accountNumber !== null &&
                        values.confirmAccountNumber !== null &&
                        routingNumber === confirmRoutingNumber &&
                        values.accountNumber === values.confirmAccountNumber &&
                        confirmRoutingNumber.length === 9
                      ) {
                        const data = {
                          routingNumber: confirmRoutingNumber,
                          accountNumber: values.accountNumber,
                        };
                        props.getAccountNumberData(data);
                      } else if (
                        values.Status_Code === 1 ||
                        values.Status_Code === 4
                      ) {
                        if (
                          values.accountNumber !== "" &&
                          values.accountNumber !== null &&
                          routingNumber === confirmRoutingNumber &&
                          confirmRoutingNumber.length === 9
                        ) {
                          const data = {
                            routingNumber: confirmRoutingNumber,
                            accountNumber: values.accountNumber,
                          };
                          props.getAccountNumberData(data);
                        }
                      }
                    }}
                    helperText={
                      validationError.confirmRoutingNumber &&
                      values.confirmRoutingNumber !== "" &&
                      values.routingNumber !== values.confirmRoutingNumber &&
                      "Routing number does not match"
                    }
                    name="confirmRoutingNumber"
                    id="confirmRoutingNumber"
                    type="text"
                  />
                </Grid>
              )}
            </Grid>

            <Grid container className={classes.margin}>
              <Grid item lg={6} sm={3} xs={12}>
                <AccountBalanceIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <TextField
                  disabled={filedsDisabled ? filedsDisabled :
                    (profileCode ===
                      profileCodePermissionCheck.profileCode.SA &&
                      props?.merchantListData?.merchantListData &&
                      props?.merchantListData?.merchantListData?.data[0]
                        ?.Banking_Details?.bankDetailsCannotBeEdited) ||
                    (profileCode ===
                      profileCodePermissionCheck.profileCode.VCS &&
                      values.Status_Code !== 1 &&
                      values.Status_Code !== "")
                  }
                  required={rtpValue === true}
                  className={classes.quaterInput}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  onFocus={() => {
                    setIsRevealAcn(true);
                  }}
                  onBlur={() => {
                    setIsRevealAcn(false);
                  }}
                  onClick={() => {
                    setIsRevealAcn(true);
                  }}
                  onPaste={(e) => e.preventDefault()}
                  onCopy={(e) => e.preventDefault()}
                  label="Account Number"
                  error={
                    validationError.accountNumber &&
                    (values.accountNumber === "" ||
                      values.accountNumber === null ||
                      values.accountNumber === undefined ||
                      values.accountNumber !== values.confirmAccountNumber ||
                      values.accountNumber.length < 8 ||
                      values.accountNumber.length > 17)
                  }
                  helperText={
                    validationError.accountNumber &&
                      (values?.accountNumber?.length < 8 ||
                        values?.accountNumber?.length > 17)
                      ? "Min 8 to Max 17 Digit Account Number is required."
                      : null
                  }
                  value={displayAccountNumber()}
                  onChange={(e) => {
                    setSubmitDisabled(false);
                    const accountNumber = e.target.value;
                    const confirmAccountNumber = values.confirmAccountNumber;
                    if (
                      values.routingNumber !== "" &&
                      values.confirmRoutingNumber !== "" &&
                      confirmAccountNumber !== "" &&
                      values.routingNumber !== null &&
                      values.confirmRoutingNumber !== null &&
                      confirmAccountNumber === accountNumber &&
                      values.routingNumber === values.confirmRoutingNumber &&
                      accountNumber.length >= 8 &&
                      accountNumber.length <= 17
                    ) {
                      const data = {
                        routingNumber: values.routingNumber,
                        accountNumber,
                      };
                      props.getAccountNumberData(data);
                    } else if (
                      values.Status_Code === 1 ||
                      values.Status_Code === 4
                    ) {
                      if (
                        values.routingNumber !== "" &&
                        values.routingNumber !== null &&
                        confirmAccountNumber === accountNumber &&
                        accountNumber.length >= 8 &&
                        accountNumber.length <= 17
                      ) {
                        const data = {
                          routingNumber: values.routingNumber,
                          accountNumber,
                        };
                        props.getAccountNumberData(data);
                      }
                    }
                    if (
                      /^[0-9]*$/g.test(e.target.value) ||
                      e.target.value === ""
                    ) {
                      onChange(e.target.value, "accountNumber");
                      if (props.accountNumberData?.status === false) {
                        clearAccountNumberData();
                      }
                    }
                  }}
                  name="accountNumber"
                  id="accountNumber"
                  type="text"
                />
                {!confirmAccountNumberVisible &&
                  values.Status_Code === 1 &&
                  ((values.routingNumber === values.confirmRoutingNumber ||
                    values.accountNumber === values.confirmAccountNumber) &&
                    props?.accountNumberData?.status ? (
                    <CheckIcon style={{ color: "green" }} />
                  ) : props?.accountNumberData?.status ? (
                    clearAccountNumberData()
                  ) : (
                    ""
                  ))}
              </Grid>
              {confirmAccountNumberVisible && (
                <Grid item lg={6} sm={3} xs={12}>
                  <AccountBalanceIcon
                    className={classes.inputBox}
                    fontSize="small"
                  />
                  <TextField
                    disabled={filedsDisabled ? filedsDisabled :
                      (profileCode ===
                        profileCodePermissionCheck.profileCode.SA &&
                        props?.merchantListData?.merchantListData &&
                        props?.merchantListData?.merchantListData?.data[0]
                          ?.Banking_Details?.bankDetailsCannotBeEdited) ||
                      (profileCode ===
                        profileCodePermissionCheck.profileCode.VCS &&
                        values.Status_Code !== 1 &&
                        values.Status_Code !== "")
                    }
                    required={values.accountNumber !== ""}
                    className={classes.quaterInput}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLableColor,
                        focused: "focused",
                      },
                    }}
                    InputProps={{
                      inputProps: { min: 0 },
                      classes: {
                        root: classes.activeInputColor,
                        input: classes.resize,
                        focused: "focused",
                      },
                    }}
                    onPaste={(e) => e.preventDefault()}
                    onCopy={(e) => e.preventDefault()}
                    label="Confirm Account Number"
                    error={
                      validationError.confirmAccountNumber &&
                      (values.confirmAccountNumber === "" ||
                        values.confirmAccountNumber !== values.accountNumber)
                    }
                    onFocus={() => {
                      setIsRevealAcnConfirm(true);
                    }}
                    onBlur={() => {
                      setIsRevealAcnConfirm(false);
                    }}
                    onClick={() => {
                      setIsRevealAcnConfirm(true);
                    }}
                    helperText={
                      validationError.confirmAccountNumber &&
                      values.confirmAccountNumber !== "" &&
                      values.accountNumber !== values.confirmAccountNumber &&
                      "Account number does not match"
                    }
                    onChange={(e) => {
                      setSubmitDisabled(false);
                      const accountNumber = values.accountNumber;
                      const confirmAccountNumber = e.target.value;

                      if (
                        (/^[0-9]*$/g.test(confirmAccountNumber) ||
                          confirmAccountNumber === "") &&
                        confirmAccountNumber.length <= 17
                      ) {
                        onChange(confirmAccountNumber, "confirmAccountNumber");
                        if (props.accountNumberData?.status === false) {
                          clearAccountNumberData();
                        }
                      }

                      if (
                        values.routingNumber !== "" &&
                        values.confirmRoutingNumber !== "" &&
                        values.routingNumber !== null &&
                        values.confirmRoutingNumber !== null &&
                        accountNumber === confirmAccountNumber &&
                        values.routingNumber === values.confirmRoutingNumber &&
                        confirmAccountNumber.length >= 8 &&
                        confirmAccountNumber.length <= 17
                      ) {
                        const data = {
                          routingNumber: values.routingNumber,
                          accountNumber: confirmAccountNumber,
                        };
                        props.getAccountNumberData(data);
                      } else if (
                        values.Status_Code === 1 ||
                        values.Status_Code === 4
                      ) {
                        if (
                          values.routingNumber !== "" &&
                          values.routingNumber !== null &&
                          accountNumber === confirmAccountNumber &&
                          confirmAccountNumber.length >= 8 &&
                          confirmAccountNumber.length <= 17
                        ) {
                          const data = {
                            routingNumber: values.routingNumber,
                            accountNumber: confirmAccountNumber,
                          };
                          props.getAccountNumberData(data);
                        }
                      }
                    }}
                    value={displayConfirmAccountNumber()}
                    name="confirmAccountNumber"
                    id="confirmAccountNumber"
                    type="text"
                  />
                  {values.Status_Code === 1 || values.Status_Code === 4 ? (
                    (values.routingNumber === values.confirmRoutingNumber ||
                      values.accountNumber === values.confirmAccountNumber) &&
                      props?.accountNumberData?.status ? (
                      <CheckIcon style={{ color: "green" }} />
                    ) : props?.accountNumberData?.status ? (
                      clearAccountNumberData()
                    ) : (
                      ""
                    )
                  ) : values.accountNumber === values.confirmAccountNumber &&
                    values.routingNumber === values.confirmRoutingNumber &&
                    props?.accountNumberData?.status ? (
                    <CheckIcon style={{ color: "green" }} />
                  ) : props?.accountNumberData?.status ? (
                    clearAccountNumberData()
                  ) : (
                    ""
                  )}
                </Grid>
              )}
              {props.accountNumberData?.status === false &&
                props?.accountNumberData.Business_Name == null ? (
                <Typography style={{ paddingLeft: "38px", color: "red" }}>
                  {`"${props?.accountNumberData?.message}"`}
                </Typography>
              ) : (
                ""
              )}
              {profileCode === profileCodePermissionCheck.profileCode.VCS &&
                props.accountNumberData?.status === false &&
                props?.accountNumberData?.Business_Name != null ? (
                <Typography style={{ paddingLeft: "38px", color: "red" }}>
                  {`This Account and Routing Number combination is already linked
              with business "${props?.accountNumberData?.Business_Name}",
              managed by "${props?.accountNumberData?.Manager_Name}"`}
                </Typography>
              ) : (
                ""
              )}
              {profileCode !== profileCodePermissionCheck.profileCode.VCS &&
                props.accountNumberData?.status === false &&
                props?.accountNumberData?.Business_Name != null ? (
                <Typography style={{ paddingLeft: "38px", color: "red" }}>
                  Please enter correct account number and routing number
                </Typography>
              ) : (
                ""
              )}
              {profileCode !==
                (profileCodePermissionCheck.profileCode.SA ||
                  profileCodePermissionCheck.profileCode.ADM) && (
                  <Grid
                    item
                    sx={{
                      display: "flex",
                      justifyContent: {
                        xl: "center",
                        lg: "center",
                        md: "flex-start",
                      },
                      alignItems: "center",
                      alignContent: "center",
                    }}
                    lg={12}
                    sm={6}
                    xs={3}
                  >
                    <FormControl
                      className={classes.root}
                      inputlabelprops={{
                        classes: {
                          root: classes.activeInputLableColor,
                          focused: "focused",
                        },
                      }}
                      component="fieldset"
                    >
                      <FormGroup
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignContent: "center",
                          alignItems: "center",
                          flexWrap: "nowrap",
                        }}
                        row
                      >
                        <FormLabel
                          style={{ marginTop: "10px", fontSize: "14px" }}
                          component="span"
                        >
                          Bank details cannot be edited by business
                        </FormLabel>
                        <FormControlLabel
                          style={{ marginTop: "10px", marginLeft: "10px" }}
                          control={(
                            <Checkbox
                              color="primary"
                              checked={
                                values.bankDetailsCannotBeEdited && !disabled1
                              }
                              disabled={
                                values.accountNumber === "" ||
                                values.routingNumber === "" ||
                                disabled1 ||
                                (values.Status_Code !== 1 &&
                                  values.Status_Code !== "")
                              }
                              onChange={(e) => {
                                setSubmitDisabled(false);
                                handleBankDetailsCheckboxChange(e);
                              }}
                              name="bankDetailsCannotBeEdited"
                            />
                          )}
                        />
                      </FormGroup>
                      <FormHelperText>
                        {validationError.bankDetailsCannotBeEdited}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                )}
            </Grid>
            {values.Account_id !== undefined && (
              <Grid
                item
                lg={4}
                sm={6}
                xs={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#696969",
                }}
                className={classes.margin}
              >
                <AccountBalanceIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <Typography>Account ID :{values.Account_id ?? ""} </Typography>
              </Grid>
            )}

            <Divider style={{ marginTop: "20px", marginBottom: "10px" }} />
          </Box>
          <Box
            style={{
              alignItems: "center",
              marginTop: "30px",
            }}
            className={classes.tittleColor}
            height={40}
          >
            <Typography className={classes.tittleTextColor}>
              Fee Details
            </Typography>
          </Box>
          <Grid container className={classes.margin}>
            <Grid item lg={4} sm={6} xs={12}>
              <AccountBalanceIcon
                className={classes.inputBox}
                fontSize="small"
              />
              <TextField
                select
                disabled={
                  (profileCode === profileCodePermissionCheck.profileCode.SA &&
                    props?.merchantListData?.merchantListData &&
                    props?.merchantListData?.merchantListData?.data[0]?.FeeType
                      ?.feeCanNotBeEdited) ||
                  (filedsDisabled)
                }
                required={rtpValue === true}
                className={classes.root}
                inputlabelprops={{
                  classes: {
                    root: classes.activeInputLabelColor,
                    focused: "focused",
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.activeInputColor,
                    input: classes.resize,
                    focused: "focused",
                  },
                  required: rtpValue === true,
                }}
                label="Fee Rate"
                error={validationError.feeRate}
                value={values.feeRate ?? ""}
                onChange={(e) => {
                  setSubmitDisabled(false);
                  onChange(e.target.value, "feeRate");
                }}
                helperText={validationError.feeRate && "Fee Rate is required."}
                name="feeRate"
                id="feeRate"
              >
                <MenuItem
                  className={classes.dialogBoxDropDown}
                  value="Per Transaction"
                >
                  Per Transaction
                </MenuItem>
                <MenuItem
                  className={classes.dialogBoxDropDown}
                  value="Percentage"
                >
                  Percentage
                </MenuItem>
                <MenuItem
                  className={classes.dialogBoxDropDown}
                  value="Per transaction + Percentage"
                >
                  Per transaction + Percentage
                </MenuItem>
                <MenuItem className={classes.dialogBoxDropDown} value="None">
                  None
                </MenuItem>
              </TextField>
            </Grid>
            {values.feeRate === "Per Transaction" && (
              <Grid item lg={4} sm={6} xs={12}>
                <AccountBalanceIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <TextField
                  disabled={
                    (profileCode ===
                      profileCodePermissionCheck.profileCode.SA &&
                      props?.merchantListData?.merchantListData &&
                      props?.merchantListData?.merchantListData?.data[0]
                        ?.FeeType?.feeCanNotBeEdited) ||
                    (filedsDisabled)
                  }
                  className={classes.root}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLabelColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  label="Per Transaction Fee"
                  value={values.perTransactionFee ?? ""}
                  name="perTransactionFee"
                  id="perTransactionFee"
                  type="number"
                  onChange={(e) =>
                    onChange(e.target.value, "perTransactionFee")
                  }
                  error={validationError.perTransactionFee}
                  helperText={
                    validationError.perTransactionFee && "Fee Rate is required."
                  }
                />
              </Grid>
            )}
            {values.feeRate === "Percentage" && (
              <Grid item lg={4} sm={6} xs={12}>
                <AccountBalanceIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <TextField
                  disabled={
                    (profileCode ===
                      profileCodePermissionCheck.profileCode.SA &&
                      props?.merchantListData?.merchantListData &&
                      props?.merchantListData?.merchantListData?.data[0]
                        ?.FeeType?.feeCanNotBeEdited) ||
                    (filedsDisabled)
                  }
                  className={classes.root}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLabelColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  label="Percentage Fee"
                  value={values.percentageFee ?? ""}
                  name="percentageFee"
                  id="percentageFee"
                  type="number"
                  onChange={(e) => onChange(e.target.value, "percentageFee")}
                  error={validationError.percentageFee}
                  helperText={
                    validationError.percentageFee && "Fee Rate is required."
                  }
                />
              </Grid>
            )}
            {values.feeRate === "Per transaction + Percentage" && (
              <>
                <Grid item lg={4} sm={6} xs={12} style={{ display: "flex" }}>
                  <div>
                    <Typography className={classes.feetype}>
                      <b>Per tran fee</b>
                    </Typography>
                  </div>
                  <AccountBalanceIcon
                    className={classes.inputBox}
                    fontSize="small"
                  />
                  <TextField
                    disabled={
                      (profileCode ===
                        profileCodePermissionCheck.profileCode.SA &&
                        props?.merchantListData?.merchantListData &&
                        props?.merchantListData?.merchantListData?.data[0]
                          ?.FeeType?.feeCanNotBeEdited) ||
                      (filedsDisabled)
                    }
                    className={classes.root}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLabelColor,
                        focused: "focused",
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.activeInputColor,
                        input: classes.resize,
                        focused: "focused",
                      },
                    }}
                    label="Per Transaction Fee"
                    value={values.perTransactionFee ?? ""}
                    name="perTransactionFee"
                    id="perTransactionFee"
                    type="number"
                    onChange={(e) =>
                      onChange(e.target.value, "perTransactionFee")
                    }
                    error={validationError.perTransactionFee}
                    helperText={
                      validationError.perTransactionFee &&
                      "Fee Rate is required."
                    }
                  />
                </Grid>
                <Grid item lg={4} sm={6} xs={12} style={{ display: "flex" }}>
                  <div>
                    <Typography className={classes.feetype}>
                      <b>Plus</b>
                    </Typography>
                  </div>
                  <AccountBalanceIcon
                    className={classes.inputBox}
                    fontSize="small"
                  />
                  <TextField
                    disabled={
                      (profileCode ===
                        profileCodePermissionCheck.profileCode.SA &&
                        props?.merchantListData?.merchantListData &&
                        props?.merchantListData?.merchantListData?.data[0]
                          ?.FeeType?.feeCanNotBeEdited) ||
                      (filedsDisabled)
                    }
                    className={classes.root}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLabelColor,
                        focused: "focused",
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.activeInputColor,
                        input: classes.resize,
                        focused: "focused",
                      },
                    }}
                    label="Percentage Fee"
                    value={values.percentageFee ?? ""}
                    name="percentageFee"
                    id="percentageFee"
                    type="number"
                    onChange={(e) => onChange(e.target.value, "percentageFee")}
                    error={validationError.percentageFee}
                    helperText={
                      validationError.percentageFee && "Fee Rate is required."
                    }
                  />
                  <div>
                    <Typography className={classes.feetype}>
                      <b>%</b>
                    </Typography>
                  </div>
                </Grid>
                <Grid item lg={4} sm={6} xs={12} style={{ display: "flex" }}>
                  <div>
                    <Typography className={classes.feetype}>
                      <b>Above</b>
                    </Typography>
                  </div>
                  <AccountBalanceIcon
                    className={classes.inputBox}
                    fontSize="small"
                  />
                  <TextField
                    disabled={
                      (profileCode ===
                        profileCodePermissionCheck.profileCode.SA &&
                        props?.merchantListData?.merchantListData &&
                        props?.merchantListData?.merchantListData?.data[0]
                          ?.FeeType?.feeCanNotBeEdited) ||
                      (filedsDisabled)
                    }
                    className={classes.root}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLabelColor,
                        focused: "focused",
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.activeInputColor,
                        input: classes.resize,
                        focused: "focused",
                      },
                    }}
                    label="Transaction Value"
                    value={values.aboveTransactionValue ?? ""}
                    name="aboveTransactionValue"
                    id="aboveTransactionValue"
                    type="text"
                    onChange={(e) =>
                      onChange(e.target.value, "aboveTransactionValue")
                    }
                    error={validationError.aboveTransactionValue}
                    helperText={
                      validationError.aboveTransactionValue &&
                      "Fee Rate is required."
                    }
                  />
                </Grid>
              </>
            )}
            {profileCode !==
              (profileCodePermissionCheck.profileCode.SA ||
                profileCodePermissionCheck.profileCode.ADM) && (
                <Grid
                  item
                  sx={{
                    display: "flex",
                    justifyContent: {
                      xl: "center",
                      lg: "center",
                      md: "flex-start",
                    },
                    alignItems: "center",
                    alignContent: "center",
                  }}
                  lg={12}
                  sm={6}
                  xs={3}
                >
                  <FormControl
                    className={classes.root}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLableColor,
                        focused: "focused",
                      },
                    }}
                    component="fieldset"
                  >
                    <FormGroup
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignContent: "center",
                        alignItems: "center",
                        flexWrap: "nowrap",
                      }}
                      row
                    >
                      <FormLabel
                        style={{ marginTop: "10px", fontSize: "14px" }}
                        component="span"
                      >
                        Fee cannot be edited by business
                      </FormLabel>
                      <FormControlLabel
                        style={{ marginTop: "10px", marginLeft: "10px" }}
                        control={(
                          <Checkbox
                            color="primary"
                            checked={values.feeCanNotBeEdited ?? false}
                            disabled={
                              (values.feeRate !== "Per Transaction" &&
                                values.feeRate !== "Percentage" &&
                                values.feeRate !==
                                "Per transaction + Percentage" &&
                                values.feeRate !== "None") ||
                              (values.Status_Code !== 1 &&
                                values.Status_Code !== "")
                            }
                            onChange={(e) => {
                              setSubmitDisabled(false);
                              handleEditFeeCheckboxChange(e);
                            }}
                            name="feeCanNotBeEdited"
                          />
                        )}
                      />
                    </FormGroup>
                    <FormHelperText>{validationError.readOnly}</FormHelperText>
                  </FormControl>
                </Grid>
              )}
          </Grid>
        </>
      )}
      {achValue && (
        <>
          <Box
            style={{
              alignItems: "center",
              marginTop: "30px",
            }}
            className={classes.tittleColor}
            height={40}
          >
            <Typography className={classes.tittleTextColor}>
              Management Group Details
            </Typography>
          </Box>
          <Grid
            container
            className={classes.margin}
            style={{ textAlign: "center" }}
          >
            <Grid style={{ marginTop: "10px" }} item lg={12} sm={6} xs={12}>
              <Button
                variant="contained"
                className={classes.buttonStyle}
                onClick={() => {
                  handleAssignGroup();
                }}
                disabled={filedsDisabled}
              >
                Assign Merchant Group
              </Button>
            </Grid>
            <Box
              mt={2}
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                width: "100%",
              }}
            >
              {selectedRows.map((row, index) => (
                <Chip
                  className={classes.chip}
                  key={index}
                  disabled={
                    filedsDisabled
                  }
                  label={`${row.name}`}
                  onDelete={() => {
                    setSubmitDisabled(false);
                    handleDeleteChip(row);
                  }}
                  deleteIcon={<CloseIcon />}
                />
              ))}
            </Box>
            {values.Balance_Check_Provider === "DecisionLogic" ? (
              <Grid
                style={{
                  display: "flex",
                  justifyContent: "end",
                  paddingRight: "10px",
                }}
                item
                lg={6}
                sm={6}
                xs={12}
              >
                <TextField
                  required
                  style={{ width: "50%", marginTop: "10px" }}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  disabled={
                    filedsDisabled
                  }
                  label="Open Banking Solution Provider"
                  value={values.Balance_Check_Provider || []}
                  error={validationError.balanceCheckProvider}
                  onChange={(e) => {
                    let newValue = e.target.value;

                    if (newValue.includes("None")) {
                      // If "None" is selected
                      if (
                        values.Balance_Check_Provider?.includes("None") &&
                        newValue.length > 1
                      ) {
                        // Case: "None" was selected, but now user picks something else → remove "None"
                        newValue = newValue.filter((val) => val !== "None");
                      } else {
                        // Case: User explicitly picked "None" → reset all, keep only "None"
                        newValue = ["None"];
                      }
                    } else {
                      // Case: Only other options, make sure "None" is never included
                      newValue = newValue.filter((val) => val !== "None");
                    }

                    setSubmitDisabled(false);
                    setBalanceCheckProvider(newValue);
                    onChange(newValue, "balanceCheckProvider");
                  }}
                  helperText={
                    validationError.balanceCheckProvider &&
                    "Open Banking Provider is required."
                  }
                  name="balanceCheckProvider"
                  id="balanceCheckProvider"
                  select
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) => selected.join(", "), // comma-separated
                  }}
                >
                  {props.roles?.lookupMasterData?.data[0]?.LookUp_Detail
                    ?.slice() // create copy, don't mutate original array
                    ?.sort((a, b) => a.Sequence - b.Sequence)
                    ?.map((item) => (
                      <MenuItem
                        key={item._id}
                        className={classes.openClasses}
                        value={item.Lookup_Detail_Name}
                      >
                        <Checkbox
                          color="primary"
                          checked={
                            values.Balance_Check_Provider?.indexOf(
                              item.Lookup_Detail_Name
                            ) > -1
                          }
                        />
                        <ListItemText
                          color="primary"
                          primary={item.Lookup_Detail_Name}
                        />
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
            ) : (
              <Grid item lg={12} sm={6} xs={12}>
                <TextField
                  required
                  style={{ width: "50%", marginTop: "10px" }}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  disabled={
                    filedsDisabled
                  }
                  label="Open Banking Solution Provider"
                  value={
                    Array.isArray(values.Balance_Check_Provider)
                      ? values.Balance_Check_Provider
                      : []
                  }
                  error={validationError.balanceCheckProvider}
                  onChange={(e) => {
                    let newValue = e.target.value;

                    if (newValue.includes("None")) {
                      // If "None" is selected
                      if (
                        values.Balance_Check_Provider?.includes("None") &&
                        newValue.length > 1
                      ) {
                        // Case: "None" was selected, but now user picks something else → remove "None"
                        newValue = newValue.filter((val) => val !== "None");
                      } else {
                        //  Case: User explicitly picked "None" → reset all, keep only "None"
                        newValue = ["None"];
                      }
                    } else {
                      // Case: Only other options, make sure "None" is never included
                      newValue = newValue.filter((val) => val !== "None");
                    }

                    setSubmitDisabled(false);
                    setBalanceCheckProvider(newValue);
                    onChange(newValue, "balanceCheckProvider");
                  }}
                  helperText={
                    validationError.balanceCheckProvider &&
                    "Balance Check State is required."
                  }
                  name="balanceCheckProvider"
                  id="balanceCheckProvider"
                  select
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) => selected.join(", "), // comma-separated
                  }}
                >
                  {props.roles?.lookupMasterData?.data[0]?.LookUp_Detail
                    ?.slice() // create copy, don't mutate original array
                    ?.sort((a, b) => a.Sequence - b.Sequence)
                    ?.map((item) => (
                      <MenuItem
                        key={item._id}
                        className={classes.openClasses}
                        value={item.Lookup_Detail_Name}
                      >
                        <Checkbox
                          color="primary"
                          checked={
                            values.Balance_Check_Provider?.indexOf(
                              item.Lookup_Detail_Name
                            ) > -1
                          }
                        />
                        <ListItemText
                          color="primary"
                          primary={item.Lookup_Detail_Name}
                        />
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
            )}
            {serviceKeyVisible === true ? (
              <Grid
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingLeft: "10px",
                }}
                item
                lg={12}
                sm={12}
                xs={12}
              >
                <TextField
                  className={classes.root}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLabelColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  disabled={
                    filedsDisabled
                  }
                  required
                  style={{ width: "50%", marginTop: "10px" }}
                  label="Service key for Decision Logic"
                  value={values.serviceKey ?? ""}
                  name="Service key for Decision Logic"
                  id="serviceKey"
                  type="text"
                  onChange={(e) => {
                    setSubmitDisabled(false);
                    onChange(e.target.value, "serviceKey");
                  }}
                  error={validationError.serviceKey}
                  helperText={
                    validationError.serviceKey && "Service Key is required."
                  }
                />
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </>
      )}
      {checkValue && (
        <>
          <Box
            style={{
              alignItems: "center",
              marginTop: "30px",
            }}
            className={classes.tittleColor}
            height={40}
          >
            <Typography className={classes.tittleTextColor}>
              sub*****
            </Typography>
          </Box>
          <Box className={classes.marginBox}>
            <Grid container className={classes.margin}>
              {/* Business Name Field */}
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  label="Notifications Webhook URL"
                  variant="standard"
                  fullWidth
                  value={inputValueNotification ?? ""}
                  onChange={handleInfoNotification}
                  required
                  error={errorNotification}
                  className={classes.root}
                  helperText={errorMessageNotification}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#002D62",
                      fontWeight: 500,
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#002D62",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#002D62",
                    },
                    "& .MuiInputBase-input": {
                      color: "#002D62",
                      fontSize: "16px",
                    },
                  }}
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  label="Notification File Size (KB)"
                  type="number"
                  variant="standard"
                  fullWidth
                  value={notificationFileSize ?? ""}
                  className={classes.root}
                  onChange={(e) => setNotificationFileSize(e.target.value)}
                  inputProps={{ min: 0 }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#002D62",
                      fontWeight: 500,
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#002D62",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#002D62",
                    },
                    "& .MuiInputBase-input": {
                      color: "#002D62",
                      fontSize: "16px",
                    },
                  }}
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  label="Transaction Status Webhook URL"
                  variant="standard"
                  fullWidth
                  value={inputValueStatus ?? ""}
                  onChange={handleInfoStatus}
                  required
                  error={errorStatus}
                  className={classes.root}
                  helperText={errorMessageStatus}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#002D62",
                      fontWeight: 500,
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#002D62",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#002D62",
                    },
                    "& .MuiInputBase-input": {
                      color: "#002D62",
                      fontSize: "16px",
                    },
                  }}
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  label="Transaction Status File Size (KB)"
                  type="number"
                  variant="standard"
                  fullWidth
                  value={statusFileSize ?? ""}
                  className={classes.root}
                  onChange={(e) => setStatusFileSize(e.target.value)}
                  inputProps={{ min: 0 }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#002D62",
                      fontWeight: 500,
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#002D62",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#002D62",
                    },
                    "& .MuiInputBase-input": {
                      color: "#002D62",
                      fontSize: "16px",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </>
      )}
      <Divider style={{ marginTop: "20px", marginBottom: "10px" }} />
      <Grid
        container
        style={{ justifyContent: "center", margin: "20px 0" }}
        className={classes.margin}
      >
        <Grid
          container
          spacing={2}
          style={{
            textAlign: "center",
            marginTop: "10px",
            justifyContent: "inherit",
            flexWrap: smallDevice ? "wrap" : "nowrap",
          }}
        >
          <Button
            variant="contained"
            className={classes.buttonStyle}
            onClick={handleBack}
          >
            Back
          </Button>

          {actionPermission(
            permissionCheck.Category.setup,
            permissionCheck.Page.merchant,
            permissionCheck.option.submit
          ) &&
            values.Status_Code === 1 &&
            profileCode === profileCodePermissionCheck.profileCode.VCS && (
              <Button
                variant="contained"
                className={classes.buttonStyle}
                id="saveDraftBusinessForm"
                onClick={() => handleFormSubmit("update")}
                disabled={
                  accountAccessibility.length === 0 ||
                  submitDisabled ||
                  (achValue && selectedRows.length === 0)
                }
              >
                Update
              </Button>
            )}
          {actionPermission(
            permissionCheck.Category.setup,
            permissionCheck.Page.merchant,
            permissionCheck.option.submit
          ) &&
            values.Status_Code === 4 &&
            profileCode === profileCodePermissionCheck.profileCode.SA && (
              <Button
                variant="contained"
                className={classes.buttonStyle}
                id="saveDraftBusinessForm"
                onClick={() => handleFormSubmit("submit")}
              >
                Submit
              </Button>
            )}
          {/* {(actionPermission(
            permissionCheck.Category.setup,
            permissionCheck.Page.merchant,
            permissionCheck.option.submit
          ) &&
            values.Status_Code !== 3 &&
            values.Status_Code === 1) ||
            (values.Status_Code === 4 && (
              <Button
                variant="contained"
                className={classes.buttonStyle}
                id="saveDraftBusinessForm"
                onClick={() => handleFormSubmit("submit")}
                disabled={
                  values.Status_Code === 3 ||
                  profileCode === profileCodePermissionCheck.profileCode.VCS
                }
              >
                Submit
              </Button>
            ))} */}

          {(actionPermission(
            permissionCheck.Category.setup,
            permissionCheck.Page.merchant,
            permissionCheck.option.inviteManager
          ) &&
            values.Status_Code !== 1 &&
            values.Status_Code !== 3 &&
            values.Status_Code === 1) ||
            ((values.Status_Code == null ||
              values.Status_Code === "" ||
              values.Status_Code === 2) && (
                <>
                  {props?.merchantListData?.emailData?.Mg_Status ===
                    "Not Active" ? (
                    <Button
                      variant="contained"
                      disabled
                      className={classes.buttonStyle}
                      onClick={() => onFormSubbmit("sendInvite")}
                    >
                      Send Invite
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      disabled={sendInviteDisabled}
                      className={classes.buttonStyle}
                      onClick={() => onFormSubbmit("sendInvite")}
                    >
                      Send Invite
                    </Button>
                  )}
                </>
              ))}
          {/* {actionPermission(
            permissionCheck.Category.setup,
            permissionCheck.Page.merchant,
            permissionCheck.option.saveDraft
          ) &&
           ( values.Status_Code == 1 &&
            values.Status_Code !== 3 ) && (
              <Button
                variant="contained"
                className={classes.buttonStyle}
                id="saveDraftBusinessForm"
                onClick={() => onFormSubbmit("saveDraft")}
                disabled={values.Status_Code == 3}
              >
                Save Draft
              </Button>
            )} */}
          {/* {actionPermission(
            permissionCheck.Category.setup,
            permissionCheck.Page.merchant,
            permissionCheck.option.saveDraft
          ) &&
            (values.Status_Code == null ||
              values.Status_Code == "") && (
              <Button
                variant="contained"
                className={classes.buttonStyle}
                id="saveDraftBusinessForm"
                onClick={() => onFormSubbmit("saveDraft")}
                disabled={values.Status_Code == 3}
              >
                Save Draft
              </Button>
            )} */}
          {/* {actionPermission(
            permissionCheck.Category.setup,
            permissionCheck.Page.merchant,
            permissionCheck.option.resendInvite
          ) &&
            values.Status_Code === 1 &&
            values.Status_Code !== 3 && (
              <Button
                variant="contained"
                className={classes.buttonStyle}
                disabled={resendInviteDisabled}
                onClick={() => onFormSubbmit("resendInvite")}
              >
                Resend Invite
              </Button>
            )} */}
        </Grid>
      </Grid>
    </div>
  );
}

Signup.propTypes = {
  disabled: PropTypes.bool,
  validationError: PropTypes.object,
  index: PropTypes.any,
  data: PropTypes.object,
  add: PropTypes.func,
  remove: PropTypes.func,
  kycCheckListFlag: PropTypes.bool,
  createPermissionFlag: PropTypes.bool,
  editPermissionFlag: PropTypes.bool,
  formData: PropTypes.object,
  getCountryTypeList: PropTypes.func,
  mainData: PropTypes.object,
  history: PropTypes.object,
  roles: PropTypes.object,
  app: PropTypes.object,
  sendInviteApiCall: PropTypes.func,
  getMerchantListData: PropTypes.func,
  getMerchantGroupCode: PropTypes.func,
  getRtpAch: PropTypes.func,
  submitApiCall: PropTypes.func,
  submitBSApiCall: PropTypes.func,
  getRoutingNumberData: PropTypes.func,
  emptyMerchantRTNReduxState: PropTypes.func,
  getAccountNumberData: PropTypes.func,
  emptyMerchantAccReduxState: PropTypes.func,
  getEmailList: PropTypes.func,
  getEmailData: PropTypes.func,
  emptyEmailListReduxState: PropTypes.func,
};

const mapStateToProps = (app) => ({
  formData: app.provideRegistration,
  mainData: app,
  roles: app.roles,
  app: app.app,
  signUpData: app,
  merchantListData: app.merchantInformation,
  marchantGroupCodeList: app.merchantInformation.marchantGroupCodeList,
  achRtpList: app.merchantInformation.achRtpList,
  routingNumberData: app.merchantInformation.routingNumberData,
  accountNumberData: app.merchantInformation.accountNumberData,
});

export default connect(mapStateToProps, {
  getCountryTypeList,
  sendInviteApiCall,
  getMerchantListData,
  getMerchantGroupCode,
  getRtpAch,
  submitApiCall,
  submitBSApiCall,
  getRoutingNumberData,
  emptyMerchantRTNReduxState,
  getAccountNumberData,
  emptyMerchantAccReduxState,
  emptyEmailListReduxState,
  getEmailList,
  getEmailData,
})(Signup);
